/* Translation of en-US.ts. Same keys, in the same order; only the
 * values are translated, and every {{placeholder}} is kept. */
export const notifications = {
  "types": {
    "feature_request_update": {
      "status": {
        "title": "طلب الميزة الخاص بك {{featureStatus}}",
        "body": "«{{request}}» {{featureStatus}}."
      },
      "reply": {
        "title": "رد على طلب الميزة الخاص بك",
        "body": "«{{request}}»: {{reply}}"
      },
      "merged": {
        "title": "طُلبت من قبل",
        "body": "«{{request}}» طُلبت من قبل. أضفنا صوتك."
      }
    },
    "feature_idea_update": {
      "default": {
        "title": "فكرة صوّتَّ لها {{featureStatus}}",
        "body": "«{{idea}}» {{featureStatus}}."
      }
    },
    "work_change_opened": {
      "default": {
        "title": "يجري تغيير المهمة",
        "body": "يقوم {{actor}} بتغيير «{{job}}». سيُطلب منك قبولها مرة أخرى."
      }
    },
    "work_changed": {
      "default": {
        "title": "تغيّرت المهمة. اقبلها مرة أخرى",
        "body": "غيّر {{actor}} «{{job}}»: {{changes}}. راجعها واقبلها مرة أخرى."
      }
    },
    "quote_scope_changed": {
      "default": {
        "title": "تغيّر النطاق الذي كنت تسعّره",
        "body": "غيّر {{actor}} «{{job}}»: {{changes}}. قدّم عرض سعر جديدًا على النطاق الجديد."
      }
    },
    "work_accepted_longer": {
      "default": {
        "title": "تم القبول، ويستغرق الآن وقتًا أطول",
        "body": "قبل {{actor}} «{{job}}» ويحتاج الآن إلى {{minutes}} دقيقة. راجع تاريخ الاستحقاق."
      }
    },
    "quote_accepted": {
      "noJob": {
        "title": "تم قبول عرض السعر الخاص بك",
        "body": "تم قبول عرض السعر الخاص بك لإحدى المهام. العمل لك."
      },
      "default": {
        "title": "تم قبول عرض السعر الخاص بك",
        "body": "تم قبول عرض السعر الخاص بك لـ «{{job}}». العمل لك."
      }
    },
    "asset_request_job_assigned": {
      "noActor": {
        "title": "تم إسناد العمل",
        "body": "أسند الفريق المهمة الخاصة بـ {{request}} إلى {{assignee}}."
      },
      "default": {
        "title": "تم إسناد العمل",
        "body": "أسند {{actor}} المهمة الخاصة بـ {{request}} إلى {{assignee}}."
      }
    },
    "asset_request_job_accepted": {
      "noActor": {
        "title": "تم قبول المهمة",
        "body": "قبِل الفريق المهمة الخاصة بـ {{request}}."
      },
      "default": {
        "title": "تم قبول المهمة",
        "body": "قبِل {{actor}} المهمة الخاصة بـ {{request}}."
      }
    },
    "asset_request_job_declined": {
      "noActor": {
        "title": "تم رفض المهمة",
        "body": "لا يستطيع الفريق تولّي المهمة الخاصة بـ {{request}}. سيجد الفريق شخصًا آخر."
      },
      "default": {
        "title": "تم رفض المهمة",
        "body": "لا يستطيع {{actor}} تولّي المهمة الخاصة بـ {{request}}. سيجد الفريق شخصًا آخر."
      }
    },
    "asset_request_job_verified": {
      "noActor": {
        "title": "تم التحقق من العمل",
        "body": "تحقّق الفريق من العمل المنجز الخاص بـ {{request}}."
      },
      "default": {
        "title": "تم التحقق من العمل",
        "body": "تحقّق {{actor}} من العمل المنجز الخاص بـ {{request}}."
      }
    },
    "asset_request_inspection_approved": {
      "noActor": {
        "title": "تم اعتماد الفحص",
        "body": "اعتمد الفريق الفحص الخاص بـ {{request}}."
      },
      "default": {
        "title": "تم اعتماد الفحص",
        "body": "اعتمد {{actor}} الفحص الخاص بـ {{request}}."
      }
    },
    "asset_request_submitted": {
      "noActor": {
        "title": "أُنشئ طلب باسمك",
        "body": "أنشأ الفريق «{{request}}» باسمك على {{asset}}."
      },
      "default": {
        "title": "أُنشئ طلب باسمك",
        "body": "أنشأ {{actor}} «{{request}}» باسمك على {{asset}}."
      }
    },
    "job_started": {
      "noActor": {
        "title": "بدأت المهمة",
        "body": "بدأ المُسنَد إليه «{{job}}»."
      },
      "default": {
        "title": "بدأت المهمة",
        "body": "بدأ {{actor}} «{{job}}»."
      }
    },
    "job_paused": {
      "noActorReason": {
        "title": "أُوقفت المهمة مؤقتًا",
        "body": "أوقف المُسنَد إليه «{{job}}» مؤقتًا. {{reason}}"
      },
      "noActor": {
        "title": "أُوقفت المهمة مؤقتًا",
        "body": "أوقف المُسنَد إليه «{{job}}» مؤقتًا."
      },
      "reason": {
        "title": "أُوقفت المهمة مؤقتًا",
        "body": "أوقف {{actor}} «{{job}}» مؤقتًا. {{reason}}"
      },
      "default": {
        "title": "أُوقفت المهمة مؤقتًا",
        "body": "أوقف {{actor}} «{{job}}» مؤقتًا."
      }
    },
    "job_resumed": {
      "noActor": {
        "title": "استُؤنفت المهمة",
        "body": "استأنف المُسنَد إليه «{{job}}»."
      },
      "default": {
        "title": "استُؤنفت المهمة",
        "body": "استأنف {{actor}} «{{job}}»."
      }
    },
    "job_evidence_added": {
      "noActor": {
        "title": "أُضيفت الأدلة",
        "body": "أضاف المُسنَد إليه الأدلة التي طلبتها في «{{job}}». راجعها لإغلاق المهمة."
      },
      "default": {
        "title": "أُضيفت الأدلة",
        "body": "أضاف {{actor}} الأدلة التي طلبتها في «{{job}}». راجعها لإغلاق المهمة."
      }
    },
    "inspection_cancelled": {
      "noActorNoAssetReason": {
        "title": "تم إلغاء الفحص",
        "body": "ألغى أحد الزملاء الفحص على أحد الأصول. {{reason}}"
      },
      "noActorNoAsset": {
        "title": "تم إلغاء الفحص",
        "body": "ألغى أحد الزملاء الفحص على أحد الأصول."
      },
      "noActorReason": {
        "title": "تم إلغاء الفحص",
        "body": "ألغى أحد الزملاء الفحص على {{asset}}. {{reason}}"
      },
      "noActor": {
        "title": "تم إلغاء الفحص",
        "body": "ألغى أحد الزملاء الفحص على {{asset}}."
      },
      "reason": {
        "title": "تم إلغاء الفحص",
        "body": "ألغى {{actor}} الفحص على {{asset}}. {{reason}}"
      },
      "default": {
        "title": "تم إلغاء الفحص",
        "body": "ألغى {{actor}} الفحص على {{asset}}."
      }
    },
    "asset_collaboration_shared": {
      "noAsset": {
        "title": "تمت مشاركة أصل معك",
        "body": "أصل — افتحه لمراجعة الوصول وقبوله."
      },
      "default": {
        "title": "تمت مشاركة أصل معك",
        "body": "{{asset}} — افتحه لمراجعة الوصول وقبوله."
      }
    },
    "asset_in_service": {
      "backNoAsset": {
        "title": "عاد الأصل إلى الخدمة",
        "body": "أحد الأصول في الخدمة. تُستأنف الجداول اعتبارًا من اليوم. {{note}}"
      },
      "backNoAssetNoNote": {
        "title": "عاد الأصل إلى الخدمة",
        "body": "أحد الأصول في الخدمة. تُستأنف الجداول اعتبارًا من اليوم."
      },
      "firstNoAsset": {
        "title": "الأصل في الخدمة",
        "body": "أحد الأصول في الخدمة. تُستأنف الجداول اعتبارًا من اليوم. {{note}}"
      },
      "firstNoAssetNoNote": {
        "title": "الأصل في الخدمة",
        "body": "أحد الأصول في الخدمة. تُستأنف الجداول اعتبارًا من اليوم."
      },
      "back": {
        "title": "عاد الأصل إلى الخدمة",
        "body": "{{asset}} في الخدمة. تُستأنف الجداول اعتبارًا من اليوم. {{note}}"
      },
      "backNoNote": {
        "title": "عاد الأصل إلى الخدمة",
        "body": "{{asset}} في الخدمة. تُستأنف الجداول اعتبارًا من اليوم."
      },
      "first": {
        "title": "الأصل في الخدمة",
        "body": "{{asset}} في الخدمة. تُستأنف الجداول اعتبارًا من اليوم. {{note}}"
      },
      "firstNoNote": {
        "title": "الأصل في الخدمة",
        "body": "{{asset}} في الخدمة. تُستأنف الجداول اعتبارًا من اليوم."
      }
    },
    "asset_out_of_service": {
      "noAsset": {
        "title": "الأصل خارج الخدمة",
        "body": "أحد الأصول خارج الخدمة ({{reason}}). جداوله متوقفة مؤقتًا حتى يُعاد تشغيله. {{note}}"
      },
      "noAssetNoNote": {
        "title": "الأصل خارج الخدمة",
        "body": "أحد الأصول خارج الخدمة ({{reason}}). جداوله متوقفة مؤقتًا حتى يُعاد تشغيله."
      },
      "noAssetNoReason": {
        "title": "الأصل خارج الخدمة",
        "body": "أحد الأصول خارج الخدمة. جداوله متوقفة مؤقتًا حتى يُعاد تشغيله. {{note}}"
      },
      "noAssetNoReasonNoNote": {
        "title": "الأصل خارج الخدمة",
        "body": "أحد الأصول خارج الخدمة. جداوله متوقفة مؤقتًا حتى يُعاد تشغيله."
      },
      "default": {
        "title": "الأصل خارج الخدمة",
        "body": "{{asset}} خارج الخدمة ({{reason}}). جداوله متوقفة مؤقتًا حتى يُعاد تشغيله. {{note}}"
      },
      "noNote": {
        "title": "الأصل خارج الخدمة",
        "body": "{{asset}} خارج الخدمة ({{reason}}). جداوله متوقفة مؤقتًا حتى يُعاد تشغيله."
      },
      "noReason": {
        "title": "الأصل خارج الخدمة",
        "body": "{{asset}} خارج الخدمة. جداوله متوقفة مؤقتًا حتى يُعاد تشغيله. {{note}}"
      },
      "noReasonNoNote": {
        "title": "الأصل خارج الخدمة",
        "body": "{{asset}} خارج الخدمة. جداوله متوقفة مؤقتًا حتى يُعاد تشغيله."
      }
    },
    "asset_owner_assigned": {
      "default": {
        "title": "مسؤولية جديدة عن أصل",
        "body": "أصبح {{asset}} من مسؤوليتك الآن."
      }
    },
    "asset_owner_removed": {
      "default": {
        "title": "تغيّرت المسؤولية عن الأصل",
        "body": "لم يعد {{asset}} من مسؤوليتك."
      }
    },
    "asset_request_approved": {
      "noAsset": {
        "title": "تمت الموافقة على طلبك",
        "body": "تمت الموافقة على «{{request}}» للأصل."
      },
      "default": {
        "title": "تمت الموافقة على طلبك",
        "body": "تمت الموافقة على «{{request}}» لـ {{asset}}."
      },
      "withNote": {
        "title": "تمت الموافقة على طلبك",
        "body": "تمت الموافقة على «{{request}}»: {{note}}"
      }
    },
    "asset_request_awaiting_customer": {
      "noAsset": {
        "title": "مطلوب إجراء بشأن طلبك",
        "body": "{{request}} بانتظار ردّك بخصوص الأصل."
      },
      "default": {
        "title": "مطلوب إجراء بشأن طلبك",
        "body": "{{request}} بانتظار ردّك بخصوص {{asset}}."
      },
      "note": {
        "title": "مطلوب إجراء بشأن طلبك",
        "body": "{{note}}"
      }
    },
    "asset_request_closed": {
      "byActor": {
        "title": "أُغلقت الحالة — اكتمل العمل كله",
        "body": "تحقّق {{actor}} من آخر الأعمال في {{request}}. اكتمل كل شيء وتم قبوله."
      },
      "default": {
        "title": "أُغلقت الحالة — اكتمل العمل كله",
        "body": "{{request}}: اكتمل كل شيء وتم قبوله. لا يلزم أي إجراء آخر."
      },
      "operatorClosed": {
        "title": "أُغلق طلبك",
        "body": "تم وضع علامة «تم» على {{request}}."
      }
    },
    "asset_request_commented": {
      "requesterNoRequestPhotoLegacy": {
        "title": "رسالة جديدة",
        "body": "مقدّم الطلب في طلب: شارك صورة."
      },
      "requesterNoRequestPhoto": {
        "title": "رسالة جديدة",
        "body": "مقدّم الطلب في طلب: شارك صورة."
      },
      "teamNoRequestPhotoLegacy": {
        "title": "رسالة جديدة",
        "body": "الفريق في طلب: شارك صورة."
      },
      "teamNoRequestPhoto": {
        "title": "رسالة جديدة",
        "body": "الفريق في طلب: شارك صورة."
      },
      "requesterPhoto": {
        "title": "رسالة جديدة",
        "body": "مقدّم الطلب في «{{request}}»: شارك صورة."
      },
      "noRequestPhotoLegacy": {
        "title": "رسالة جديدة",
        "body": "{{author}} في طلب: شارك صورة."
      },
      "noRequestPhoto": {
        "title": "رسالة جديدة",
        "body": "{{author}} في طلب: شارك صورة."
      },
      "teamPhoto": {
        "title": "رسالة جديدة",
        "body": "الفريق في «{{request}}»: شارك صورة."
      },
      "requesterNoRequestLegacy": {
        "title": "رسالة جديدة",
        "body": "مقدّم الطلب في طلب: {{message}}"
      },
      "requesterNoRequest": {
        "title": "رسالة جديدة",
        "body": "مقدّم الطلب في طلب: {{message}}"
      },
      "teamNoRequestLegacy": {
        "title": "رسالة جديدة",
        "body": "الفريق في طلب: {{message}}"
      },
      "teamNoRequest": {
        "title": "رسالة جديدة",
        "body": "الفريق في طلب: {{message}}"
      },
      "photo": {
        "title": "رسالة جديدة",
        "body": "{{author}} في «{{request}}»: شارك صورة."
      },
      "requester": {
        "title": "رسالة جديدة",
        "body": "مقدّم الطلب في «{{request}}»: {{message}}"
      },
      "noRequestLegacy": {
        "title": "رسالة جديدة",
        "body": "{{author}} في طلب: {{message}}"
      },
      "noRequest": {
        "title": "رسالة جديدة",
        "body": "{{author}} في طلب: {{message}}"
      },
      "team": {
        "title": "رسالة جديدة",
        "body": "الفريق في «{{request}}»: {{message}}"
      },
      "default": {
        "title": "رسالة جديدة",
        "body": "{{author}} في «{{request}}»: {{message}}"
      }
    },
    "asset_request_completion_accepted": {
      "verifierNoRequesterNoRequestLegacy": {
        "title": "مقدّم الطلب راضٍ — تحقّق للإغلاق",
        "body": "قبِل مقدّم الطلب العمل المكتمل في الطلب. تحقّق من المهمة لإغلاقها."
      },
      "verifierNoRequesterNoRequest": {
        "title": "مقدّم الطلب راضٍ — تحقّق للإغلاق",
        "body": "قبِل مقدّم الطلب العمل المكتمل في الطلب. تحقّق من المهمة لإغلاقها."
      },
      "verifierNoRequester": {
        "title": "مقدّم الطلب راضٍ — تحقّق للإغلاق",
        "body": "قبِل مقدّم الطلب العمل المكتمل في «{{request}}». تحقّق من المهمة لإغلاقها."
      },
      "verifierNoRequestLegacy": {
        "title": "مقدّم الطلب راضٍ — تحقّق للإغلاق",
        "body": "قبِل {{requester}} العمل المكتمل في الطلب. تحقّق من المهمة لإغلاقها."
      },
      "verifierNoRequest": {
        "title": "مقدّم الطلب راضٍ — تحقّق للإغلاق",
        "body": "قبِل {{requester}} العمل المكتمل في الطلب. تحقّق من المهمة لإغلاقها."
      },
      "verifier": {
        "title": "مقدّم الطلب راضٍ — تحقّق للإغلاق",
        "body": "قبِل {{requester}} العمل المكتمل في «{{request}}». تحقّق من المهمة لإغلاقها."
      },
      "informedNoRequesterNoRequestLegacy": {
        "title": "قبِل مقدّم الطلب العمل",
        "body": "قبِل مقدّم الطلب العمل المكتمل في الطلب."
      },
      "informedNoRequesterNoRequest": {
        "title": "قبِل مقدّم الطلب العمل",
        "body": "قبِل مقدّم الطلب العمل المكتمل في الطلب."
      },
      "informedNoRequester": {
        "title": "قبِل مقدّم الطلب العمل",
        "body": "قبِل مقدّم الطلب العمل المكتمل في «{{request}}»."
      },
      "informedNoRequestLegacy": {
        "title": "قبِل مقدّم الطلب العمل",
        "body": "قبِل {{requester}} العمل المكتمل في الطلب."
      },
      "informedNoRequest": {
        "title": "قبِل مقدّم الطلب العمل",
        "body": "قبِل {{requester}} العمل المكتمل في الطلب."
      },
      "informed": {
        "title": "قبِل مقدّم الطلب العمل",
        "body": "قبِل {{requester}} العمل المكتمل في «{{request}}»."
      }
    },
    "asset_request_completion_rejected": {
      "noActor": {
        "title": "رُفض الإنجاز",
        "body": "رفض الفريق العمل المكتمل الخاص بـ {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "رُفض الإنجاز",
        "body": "رفض الفريق العمل المكتمل الخاص بـ {{request}}."
      },
      "default": {
        "title": "رُفض الإنجاز",
        "body": "رفض {{actor}} العمل المكتمل الخاص بـ {{request}}. {{note}}"
      },
      "noNote": {
        "title": "رُفض الإنجاز",
        "body": "رفض {{actor}} العمل المكتمل الخاص بـ {{request}}."
      }
    },
    "asset_request_confirmed_schedule": {
      "requestNoRequest": {
        "title": "تم تأكيد الموعد",
        "body": "طلب — أكّد مقدّم الطلب الزيارة المجدولة."
      },
      "visitNoInspection": {
        "title": "تم تأكيد الزيارة",
        "body": "تم تأكيد زيارة الفحص في {{when}}."
      },
      "request": {
        "title": "تم تأكيد الموعد",
        "body": "{{request}} — أكّد مقدّم الطلب الزيارة المجدولة."
      },
      "visitNoJob": {
        "title": "تم تأكيد الزيارة",
        "body": "تم تأكيد زيارة المهمة في {{when}}."
      },
      "visit": {
        "title": "تم تأكيد الزيارة",
        "body": "تم تأكيد زيارة {{work}} في {{when}}."
      }
    },
    "asset_request_converted": {
      "toInspection": {
        "title": "تم تحويل طلبك إلى فحص",
        "body": "{{request}} مجدول الآن للعمل التشغيلي."
      },
      "toJob": {
        "title": "تم تحويل طلبك إلى مهمة",
        "body": "{{request}} الآن في قائمة انتظار العمل."
      },
      "inspectionUndated": {
        "title": "تمت جدولة الفحص",
        "body": "{{request}} مجدول الآن للفحص."
      },
      "jobDue": {
        "title": "أصبح طلبك مهمة",
        "body": "أصبح {{request}} مهمة لـ {{assignee}}، مستحقة بحلول {{dueDate}}."
      },
      "inspectionScheduled": {
        "title": "تمت جدولة الفحص",
        "body": "{{request}} — الفحص مجدول في {{scheduledWhen}}."
      },
      "jobDueNoAssignee": {
        "title": "أصبح طلبك مهمة",
        "body": "أصبح {{request}} مهمة، مستحقة بحلول {{dueDate}}."
      },
      "job": {
        "title": "أصبح طلبك مهمة",
        "body": "أصبح {{request}} مهمة لـ {{assignee}}."
      },
      "jobScheduled": {
        "title": "تمت جدولة المهمة",
        "body": "{{request}} — مهمة لـ {{assignee}} مجدولة في {{scheduledDate}}."
      },
      "jobNoAssignee": {
        "title": "أصبح طلبك مهمة",
        "body": "أصبح {{request}} مهمة."
      },
      "jobScheduledNoAssignee": {
        "title": "تمت جدولة المهمة",
        "body": "{{request}} — المهمة مجدولة في {{scheduledDate}}."
      }
    },
    "asset_request_created": {
      "noAssetOperatorNoRequestPublicLinkLegacy": {
        "title": "طلب جديد لأصل",
        "body": "أرسل أحد المشغّلين طلبًا عبر الرابط العام."
      },
      "noAssetOperatorNoRequestPublicLink": {
        "title": "طلب جديد لأصل",
        "body": "أرسل أحد المشغّلين طلبًا عبر الرابط العام."
      },
      "noAssetContactNoRequestPublicLinkLegacy": {
        "title": "طلب جديد لأصل",
        "body": "أرسلت إحدى جهات الاتصال طلبًا عبر الرابط العام."
      },
      "noAssetContactNoRequestPublicLink": {
        "title": "طلب جديد لأصل",
        "body": "أرسلت إحدى جهات الاتصال طلبًا عبر الرابط العام."
      },
      "operatorNoRequestPublicLinkLegacy": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسل أحد المشغّلين طلبًا عبر الرابط العام."
      },
      "operatorNoRequestPublicLink": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسل أحد المشغّلين طلبًا عبر الرابط العام."
      },
      "contactNoRequestPublicLinkLegacy": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسلت إحدى جهات الاتصال طلبًا عبر الرابط العام."
      },
      "contactNoRequestPublicLink": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسلت إحدى جهات الاتصال طلبًا عبر الرابط العام."
      },
      "noAssetOperatorPublicLink": {
        "title": "طلب جديد لأصل",
        "body": "أرسل أحد المشغّلين «{{request}}» عبر الرابط العام."
      },
      "noAssetNoRequestPublicLinkLegacy": {
        "title": "طلب جديد لأصل",
        "body": "أرسل {{submitter}} طلبًا عبر الرابط العام."
      },
      "noAssetNoRequestPublicLink": {
        "title": "طلب جديد لأصل",
        "body": "أرسل {{submitter}} طلبًا عبر الرابط العام."
      },
      "noAssetContactPublicLink": {
        "title": "طلب جديد لأصل",
        "body": "أرسلت إحدى جهات الاتصال «{{request}}» عبر الرابط العام."
      },
      "operatorPublicLink": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسل أحد المشغّلين «{{request}}» عبر الرابط العام."
      },
      "noRequestPublicLinkLegacy": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسل {{submitter}} طلبًا عبر الرابط العام."
      },
      "noRequestPublicLink": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسل {{submitter}} طلبًا عبر الرابط العام."
      },
      "contactPublicLink": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسلت إحدى جهات الاتصال «{{request}}» عبر الرابط العام."
      },
      "noAssetPublicLink": {
        "title": "طلب جديد لأصل",
        "body": "أرسل {{submitter}} «{{request}}» عبر الرابط العام."
      },
      "noAssetOperatorNoRequestLegacy": {
        "title": "طلب جديد لأصل",
        "body": "أرسل أحد المشغّلين طلبًا."
      },
      "noAssetOperatorNoRequest": {
        "title": "طلب جديد لأصل",
        "body": "أرسل أحد المشغّلين طلبًا."
      },
      "noAssetContactNoRequestLegacy": {
        "title": "طلب جديد لأصل",
        "body": "أرسلت إحدى جهات الاتصال طلبًا."
      },
      "noAssetContactNoRequest": {
        "title": "طلب جديد لأصل",
        "body": "أرسلت إحدى جهات الاتصال طلبًا."
      },
      "publicLink": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسل {{submitter}} «{{request}}» عبر الرابط العام."
      },
      "operatorNoRequestLegacy": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسل أحد المشغّلين طلبًا."
      },
      "operatorNoRequest": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسل أحد المشغّلين طلبًا."
      },
      "contactNoRequestLegacy": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسلت إحدى جهات الاتصال طلبًا."
      },
      "contactNoRequest": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسلت إحدى جهات الاتصال طلبًا."
      },
      "noAssetOperator": {
        "title": "طلب جديد لأصل",
        "body": "أرسل أحد المشغّلين «{{request}}»."
      },
      "noAssetNoRequestLegacy": {
        "title": "طلب جديد لأصل",
        "body": "أرسل {{submitter}} طلبًا."
      },
      "noAssetNoRequest": {
        "title": "طلب جديد لأصل",
        "body": "أرسل {{submitter}} طلبًا."
      },
      "noAssetContact": {
        "title": "طلب جديد لأصل",
        "body": "أرسلت إحدى جهات الاتصال «{{request}}»."
      },
      "operator": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسل أحد المشغّلين «{{request}}»."
      },
      "noRequestLegacy": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسل {{submitter}} طلبًا."
      },
      "noRequest": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسل {{submitter}} طلبًا."
      },
      "contact": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسلت إحدى جهات الاتصال «{{request}}»."
      },
      "noAsset": {
        "title": "طلب جديد لأصل",
        "body": "أرسل {{submitter}} «{{request}}»."
      },
      "default": {
        "title": "طلب جديد لـ {{asset}}",
        "body": "أرسل {{submitter}} «{{request}}»."
      }
    },
    "asset_request_evidence_requested": {
      "noAsset": {
        "title": "تم تحديث الطلب",
        "body": "تم تحديث {{request}} للأصل. {{note}}"
      },
      "noAssetNoNote": {
        "title": "تم تحديث الطلب",
        "body": "تم تحديث {{request}} للأصل."
      },
      "default": {
        "title": "تم تحديث الطلب",
        "body": "تم تحديث {{request}} لـ {{asset}}. {{note}}"
      },
      "noNote": {
        "title": "تم تحديث الطلب",
        "body": "تم تحديث {{request}} لـ {{asset}}."
      }
    },
    "asset_request_inspection_cancelled": {
      "noActor": {
        "title": "تم إلغاء الفحص",
        "body": "ألغى الفريق الفحص الخاص بـ {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "تم إلغاء الفحص",
        "body": "ألغى الفريق الفحص الخاص بـ {{request}}."
      },
      "default": {
        "title": "تم إلغاء الفحص",
        "body": "ألغى {{actor}} الفحص الخاص بـ {{request}}. {{note}}"
      },
      "noNote": {
        "title": "تم إلغاء الفحص",
        "body": "ألغى {{actor}} الفحص الخاص بـ {{request}}."
      }
    },
    "asset_request_inspection_completed": {
      "noActor": {
        "title": "اكتمل الفحص",
        "body": "أكمل الفريق الفحص الخاص بـ {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "اكتمل الفحص",
        "body": "أكمل الفريق الفحص الخاص بـ {{request}}."
      },
      "default": {
        "title": "اكتمل الفحص",
        "body": "أكمل {{actor}} الفحص الخاص بـ {{request}}. {{note}}"
      },
      "noNote": {
        "title": "اكتمل الفحص",
        "body": "أكمل {{actor}} الفحص الخاص بـ {{request}}."
      }
    },
    "asset_request_inspection_paused": {
      "noActor": {
        "title": "تم إيقاف الفحص مؤقتًا",
        "body": "أوقف الفريق الفحص الخاص بـ {{request}} مؤقتًا. {{note}}"
      },
      "noActorNoNote": {
        "title": "تم إيقاف الفحص مؤقتًا",
        "body": "أوقف الفريق الفحص الخاص بـ {{request}} مؤقتًا."
      },
      "default": {
        "title": "تم إيقاف الفحص مؤقتًا",
        "body": "أوقف {{actor}} الفحص الخاص بـ {{request}} مؤقتًا. {{note}}"
      },
      "noNote": {
        "title": "تم إيقاف الفحص مؤقتًا",
        "body": "أوقف {{actor}} الفحص الخاص بـ {{request}} مؤقتًا."
      }
    },
    "asset_request_inspection_reassigned": {
      "toAssigneeNoActor": {
        "title": "أُعيد تكليف الفحص",
        "body": "أعاد الفريق تكليف الفحص الخاص بـ {{request}} إلى {{assignee}}."
      },
      "noActor": {
        "title": "أُعيد تكليف الفحص",
        "body": "أعاد الفريق تكليف الفحص الخاص بـ {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "أُعيد تكليف الفحص",
        "body": "أعاد الفريق تكليف الفحص الخاص بـ {{request}}."
      },
      "toAssignee": {
        "title": "أُعيد تكليف الفحص",
        "body": "أعاد {{actor}} تكليف الفحص الخاص بـ {{request}} إلى {{assignee}}."
      },
      "default": {
        "title": "أُعيد تكليف الفحص",
        "body": "أعاد {{actor}} تكليف الفحص الخاص بـ {{request}}. {{note}}"
      },
      "noNote": {
        "title": "أُعيد تكليف الفحص",
        "body": "أعاد {{actor}} تكليف الفحص الخاص بـ {{request}}."
      }
    },
    "asset_request_inspection_resumed": {
      "noActorReopened": {
        "title": "استؤنف الفحص",
        "body": "استأنف الفريق الفحص الخاص بـ {{request}}. أُعيد فتح الفحص."
      },
      "reopened": {
        "title": "استؤنف الفحص",
        "body": "استأنف {{actor}} الفحص الخاص بـ {{request}}. أُعيد فتح الفحص."
      },
      "noActor": {
        "title": "استؤنف الفحص",
        "body": "استأنف الفريق الفحص الخاص بـ {{request}}."
      },
      "default": {
        "title": "استؤنف الفحص",
        "body": "استأنف {{actor}} الفحص الخاص بـ {{request}}."
      }
    },
    "asset_request_inspection_started": {
      "noActor": {
        "title": "بدأ الفحص",
        "body": "بدأ الفريق الفحص الخاص بـ {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "بدأ الفحص",
        "body": "بدأ الفريق الفحص الخاص بـ {{request}}."
      },
      "default": {
        "title": "بدأ الفحص",
        "body": "بدأ {{actor}} الفحص الخاص بـ {{request}}. {{note}}"
      },
      "noNote": {
        "title": "بدأ الفحص",
        "body": "بدأ {{actor}} الفحص الخاص بـ {{request}}."
      }
    },
    "asset_request_job_cancelled": {
      "noActor": {
        "title": "تم إلغاء المهمة",
        "body": "ألغى الفريق المهمة الخاصة بـ {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "تم إلغاء المهمة",
        "body": "ألغى الفريق المهمة الخاصة بـ {{request}}."
      },
      "default": {
        "title": "تم إلغاء المهمة",
        "body": "ألغى {{actor}} المهمة الخاصة بـ {{request}}. {{note}}"
      },
      "noNote": {
        "title": "تم إلغاء المهمة",
        "body": "ألغى {{actor}} المهمة الخاصة بـ {{request}}."
      }
    },
    "asset_request_job_completed": {
      "noActorNoJobLegacy": {
        "title": "اكتملت مهمة",
        "body": "أكمل الفريق المهمة الخاصة بطلبك. راجع العمل وأكّد الإصلاح."
      },
      "noActorNoJob": {
        "title": "اكتملت مهمة",
        "body": "أكمل الفريق المهمة الخاصة بطلبك. راجع العمل وأكّد الإصلاح."
      },
      "noJobLegacy": {
        "title": "اكتملت مهمة",
        "body": "أكمل {{actor}} المهمة الخاصة بطلبك. راجع العمل وأكّد الإصلاح."
      },
      "noJob": {
        "title": "اكتملت مهمة",
        "body": "أكمل {{actor}} المهمة الخاصة بطلبك. راجع العمل وأكّد الإصلاح."
      },
      "noActor": {
        "title": "اكتملت مهمة",
        "body": "أكمل الفريق المهمة «{{job}}». راجع العمل وأكّد الإصلاح."
      },
      "default": {
        "title": "اكتملت مهمة",
        "body": "أكمل {{actor}} المهمة «{{job}}». راجع العمل وأكّد الإصلاح."
      }
    },
    "asset_request_job_created": {
      "noActorOutsideRepairsLegacy": {
        "title": "أُنشئت مهمة من الطلب",
        "body": "أنشأ الفريق مهمة لـ {{request}} خارج الإصلاحات المعتمدة: «{{job}}»."
      },
      "outsideRepairsLegacy": {
        "title": "أُنشئت مهمة من الطلب",
        "body": "أنشأ {{actor}} مهمة لـ {{request}} خارج الإصلاحات المعتمدة: «{{job}}»."
      },
      "noActorLegacy": {
        "title": "أُنشئت مهمة من الطلب",
        "body": "أنشأ الفريق مهمة لـ {{request}}: «{{job}}»."
      },
      "noActorFromRepairLegacy": {
        "title": "أُنشئت مهمة من الطلب",
        "body": "أنشأ الفريق مهمة لـ {{request}} من إصلاح معتمد: «{{job}}»."
      },
      "noActorFollowUpLegacy": {
        "title": "أُنشئت مهمة من الطلب",
        "body": "اقترح الفريق مهمة متابعة لـ {{request}}: «{{job}}»."
      },
      "defaultLegacy": {
        "title": "أُنشئت مهمة من الطلب",
        "body": "أنشأ {{actor}} مهمة لـ {{request}}: «{{job}}»."
      },
      "fromRepairLegacy": {
        "title": "أُنشئت مهمة من الطلب",
        "body": "أنشأ {{actor}} مهمة لـ {{request}} من إصلاح معتمد: «{{job}}»."
      },
      "followUpLegacy": {
        "title": "أُنشئت مهمة من الطلب",
        "body": "اقترح {{actor}} مهمة متابعة لـ {{request}}: «{{job}}»."
      },
      "noActorOutsideRepairs": {
        "title": "أُنشئت مهمة من الطلب",
        "body": "أنشأ الفريق مهمة لـ {{request}} خارج الإصلاحات المعتمدة: «{{job}}»."
      },
      "noActorFromRepair": {
        "title": "أُنشئت مهمة من الطلب",
        "body": "أنشأ الفريق مهمة لـ {{request}} من إصلاح معتمد: «{{job}}»."
      },
      "noActorFollowUp": {
        "title": "أُنشئت مهمة من الطلب",
        "body": "اقترح الفريق مهمة متابعة لـ {{request}}: «{{job}}»."
      },
      "noActor": {
        "title": "أُنشئت مهمة من الطلب",
        "body": "أنشأ الفريق مهمة لـ {{request}}: «{{job}}»."
      },
      "outsideRepairs": {
        "title": "أُنشئت مهمة من الطلب",
        "body": "أنشأ {{actor}} مهمة لـ {{request}} خارج الإصلاحات المعتمدة: «{{job}}»."
      },
      "fromRepair": {
        "title": "أُنشئت مهمة من الطلب",
        "body": "أنشأ {{actor}} مهمة لـ {{request}} من إصلاح معتمد: «{{job}}»."
      },
      "followUp": {
        "title": "أُنشئت مهمة من الطلب",
        "body": "اقترح {{actor}} مهمة متابعة لـ {{request}}: «{{job}}»."
      },
      "default": {
        "title": "أُنشئت مهمة من الطلب",
        "body": "أنشأ {{actor}} مهمة لـ {{request}}: «{{job}}»."
      }
    },
    "asset_request_job_paused": {
      "noActor": {
        "title": "المهمة متوقفة مؤقتًا",
        "body": "أوقف الفريق المهمة الخاصة بـ {{request}} مؤقتًا. {{note}}"
      },
      "noActorNoNote": {
        "title": "المهمة متوقفة مؤقتًا",
        "body": "أوقف الفريق المهمة الخاصة بـ {{request}} مؤقتًا."
      },
      "default": {
        "title": "المهمة متوقفة مؤقتًا",
        "body": "أوقف {{actor}} المهمة الخاصة بـ {{request}} مؤقتًا. {{note}}"
      },
      "noNote": {
        "title": "المهمة متوقفة مؤقتًا",
        "body": "أوقف {{actor}} المهمة الخاصة بـ {{request}} مؤقتًا."
      }
    },
    "asset_request_job_resumed": {
      "noActor": {
        "title": "استؤنفت المهمة",
        "body": "استأنف الفريق المهمة الخاصة بـ {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "استؤنفت المهمة",
        "body": "استأنف الفريق المهمة الخاصة بـ {{request}}."
      },
      "default": {
        "title": "استؤنفت المهمة",
        "body": "استأنف {{actor}} المهمة الخاصة بـ {{request}}. {{note}}"
      },
      "noNote": {
        "title": "استؤنفت المهمة",
        "body": "استأنف {{actor}} المهمة الخاصة بـ {{request}}."
      }
    },
    "asset_request_job_started": {
      "noActor": {
        "title": "بدأت المهمة",
        "body": "بدأ الفريق المهمة الخاصة بـ {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "بدأت المهمة",
        "body": "بدأ الفريق المهمة الخاصة بـ {{request}}."
      },
      "default": {
        "title": "بدأت المهمة",
        "body": "بدأ {{actor}} المهمة الخاصة بـ {{request}}. {{note}}"
      },
      "noNote": {
        "title": "بدأت المهمة",
        "body": "بدأ {{actor}} المهمة الخاصة بـ {{request}}."
      }
    },
    "asset_request_rejected": {
      "withNote": {
        "title": "رُفض طلبك",
        "body": "رُفض «{{request}}»: {{note}}"
      },
      "default": {
        "title": "رُفض طلبك",
        "body": "رُفض «{{request}}»."
      }
    },
    "asset_request_report_shared": {
      "forYouLegacy": {
        "title": "تمت مشاركة تقرير الفحص",
        "body": "تقرير {{request}} جاهز لمراجعتك — نتائج تتطلب إجراءً: {{findingCount}}."
      },
      "defaultLegacy": {
        "title": "تمت مشاركة تقرير الفحص",
        "body": "تقرير {{request}} جاهز للمراجعة — نتائج إصلاح مقترحة: {{findingCount}}."
      },
      "forYouPlainLegacy": {
        "title": "تمت مشاركة تقرير الفحص",
        "body": "تقرير {{request}} جاهز لمراجعتك."
      },
      "plainLegacy": {
        "title": "تمت مشاركة تقرير الفحص",
        "body": "تقرير {{request}} جاهز للمراجعة."
      },
      "forYou": {
        "title": "تمت مشاركة تقرير الفحص",
        "body": "تقرير {{request}} جاهز لمراجعتك — نتائج تتطلب إجراءً: {{findingCount}}."
      },
      "default": {
        "title": "تمت مشاركة تقرير الفحص",
        "body": "تقرير {{request}} جاهز للمراجعة — نتائج إصلاح مقترحة: {{findingCount}}."
      },
      "forYouPlain": {
        "title": "تمت مشاركة تقرير الفحص",
        "body": "تقرير {{request}} جاهز لمراجعتك."
      },
      "plain": {
        "title": "تمت مشاركة تقرير الفحص",
        "body": "تقرير {{request}} جاهز للمراجعة."
      }
    },
    "asset_request_requested_reschedule": {
      "visitNoInspectionNoPreference": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف للفحص. لم يُحدَّد وقت مفضّل."
      },
      "visitNoJobNoPreference": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف للمهمة. لم يُحدَّد وقت مفضّل."
      },
      "visitNoInspection": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف للفحص. المفضّل: {{preferredDate}} · {{period}} · {{note}}"
      },
      "visitNoInspectionNoNote": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف للفحص. المفضّل: {{preferredDate}} · {{period}}"
      },
      "visitNoInspectionNoPeriod": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف للفحص. المفضّل: {{preferredDate}} · {{note}}"
      },
      "visitNoPreference": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف لـ {{work}}. لم يُحدَّد وقت مفضّل."
      },
      "visitNoInspectionDateOnly": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف للفحص. المفضّل: {{preferredDate}}"
      },
      "visitNoJob": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف للمهمة. المفضّل: {{preferredDate}} · {{period}} · {{note}}"
      },
      "visitNoJobNoNote": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف للمهمة. المفضّل: {{preferredDate}} · {{period}}"
      },
      "visitNoJobNoPeriod": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف للمهمة. المفضّل: {{preferredDate}} · {{note}}"
      },
      "visitNoInspectionNoDate": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف للفحص. {{period}} · {{note}}"
      },
      "visitNoJobDateOnly": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف للمهمة. المفضّل: {{preferredDate}}"
      },
      "visit": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف لـ {{work}}. المفضّل: {{preferredDate}} · {{period}} · {{note}}"
      },
      "visitNoInspectionPeriodOnly": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف للفحص. {{period}}"
      },
      "visitNoInspectionNoteOnly": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف للفحص. {{note}}"
      },
      "visitNoNote": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف لـ {{work}}. المفضّل: {{preferredDate}} · {{period}}"
      },
      "visitNoPeriod": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف لـ {{work}}. المفضّل: {{preferredDate}} · {{note}}"
      },
      "visitNoJobNoDate": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف للمهمة. {{period}} · {{note}}"
      },
      "requestNoRequest": {
        "title": "طُلب وقت جديد",
        "body": "طلب — طلب مقدّم الطلب وقتًا مختلفًا. ({{preferredDate}} {{periodLabel}})"
      },
      "requestNoRequestNoPeriod": {
        "title": "طُلب وقت جديد",
        "body": "طلب — طلب مقدّم الطلب وقتًا مختلفًا. ({{preferredDate}})"
      },
      "visitDateOnly": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف لـ {{work}}. المفضّل: {{preferredDate}}"
      },
      "visitNoJobPeriodOnly": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف للمهمة. {{period}}"
      },
      "visitNoJobNoteOnly": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف للمهمة. {{note}}"
      },
      "requestNoRequestNoPreference": {
        "title": "طُلب وقت جديد",
        "body": "طلب — طلب مقدّم الطلب وقتًا مختلفًا."
      },
      "visitNoDate": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف لـ {{work}}. {{period}} · {{note}}"
      },
      "request": {
        "title": "طُلب وقت جديد",
        "body": "{{request}} — طلب مقدّم الطلب وقتًا مختلفًا. ({{preferredDate}} {{periodLabel}})"
      },
      "requestNoPeriod": {
        "title": "طُلب وقت جديد",
        "body": "{{request}} — طلب مقدّم الطلب وقتًا مختلفًا. ({{preferredDate}})"
      },
      "visitPeriodOnly": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف لـ {{work}}. {{period}}"
      },
      "visitNoteOnly": {
        "title": "طُلب وقت مختلف للزيارة",
        "body": "طُلب وقت مختلف لـ {{work}}. {{note}}"
      },
      "requestNoPreference": {
        "title": "طُلب وقت جديد",
        "body": "{{request}} — طلب مقدّم الطلب وقتًا مختلفًا."
      }
    },
    "asset_request_requester_cancelled": {
      "noRequest": {
        "title": "سُحب الطلب",
        "body": "سحب مقدّم الطلب طلبه. {{reason}}"
      },
      "noRequestNoReason": {
        "title": "سُحب الطلب",
        "body": "سحب مقدّم الطلب طلبه."
      },
      "default": {
        "title": "سُحب الطلب",
        "body": "سحب مقدّم الطلب {{request}}. {{reason}}"
      },
      "noReason": {
        "title": "سُحب الطلب",
        "body": "سحب مقدّم الطلب {{request}}."
      }
    },
    "asset_request_response_received": {
      "approvedLegacy": {
        "title": "تم استلام رد على التقرير",
        "body": "تمت الموافقة على تقرير {{request}}."
      },
      "rejectedLegacy": {
        "title": "تم استلام رد على التقرير",
        "body": "رُفض تقرير {{request}}."
      },
      "defaultLegacy": {
        "title": "تم استلام رد على التقرير",
        "body": "رُفض تقرير {{request}}. {{reason}}"
      },
      "approved": {
        "title": "تم استلام رد على التقرير",
        "body": "تمت الموافقة على تقرير {{request}}."
      },
      "rejected": {
        "title": "تم استلام رد على التقرير",
        "body": "رُفض تقرير {{request}}."
      },
      "default": {
        "title": "تم استلام رد على التقرير",
        "body": "رُفض تقرير {{request}}. {{reason}}"
      }
    },
    "asset_request_rework_requested": {
      "requesterNoRequesterNoRequestNoReasonLegacy": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب مقدّم الطلب إعادة العمل في الطلب."
      },
      "requesterNoRequesterNoReasonLegacy": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب مقدّم الطلب إعادة العمل في «{{request}}»."
      },
      "requesterNoRequestNoReasonLegacy": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب {{requester}} إعادة العمل في الطلب."
      },
      "requesterNoReasonLegacy": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب {{requester}} إعادة العمل في «{{request}}»."
      },
      "requesterNoRequesterNoRequestLegacy": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب مقدّم الطلب إعادة العمل في الطلب: {{reason}}"
      },
      "requesterNoRequestLegacy": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب {{requester}} إعادة العمل في الطلب: {{reason}}"
      },
      "requesterNoRequesterNoRequestNoReason": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب مقدّم الطلب إعادة العمل في الطلب."
      },
      "requesterNoRequesterNoReason": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب مقدّم الطلب إعادة العمل في «{{request}}»."
      },
      "requesterNoRequestNoReason": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب {{requester}} إعادة العمل في الطلب."
      },
      "requesterNoReason": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب {{requester}} إعادة العمل في «{{request}}»."
      },
      "requesterNoRequesterNoRequest": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب مقدّم الطلب إعادة العمل في الطلب: {{reason}}"
      },
      "requesterNoRequester": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب مقدّم الطلب إعادة العمل في «{{request}}»: {{reason}}"
      },
      "requesterNoRequest": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب {{requester}} إعادة العمل في الطلب: {{reason}}"
      },
      "teamNoActor": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب الفريق إعادة العمل في {{request}}. {{note}}"
      },
      "teamNoActorNoNote": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب الفريق إعادة العمل في {{request}}."
      },
      "requester": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب {{requester}} إعادة العمل في «{{request}}»: {{reason}}"
      },
      "team": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب {{actor}} إعادة العمل في {{request}}. {{note}}"
      },
      "teamNoNote": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب {{actor}} إعادة العمل في {{request}}."
      }
    },
    "asset_request_scheduled": {
      "scheduled": {
        "title": "تمت جدولة طلبك",
        "body": "{{request}} مجدول في {{scheduledDate}}."
      },
      "rescheduled": {
        "title": "تمت إعادة جدولة زيارتك",
        "body": "{{request}} — الموعد الجديد {{newWhen}}."
      }
    },
    "asset_retired": {
      "noAsset": {
        "title": "أُخرج الأصل من الخدمة نهائيًا",
        "body": "أُخرج أحد الأصول من الخدمة نهائيًا ({{reason}}). لن يقبل فحوصات أو مهام جديدة. {{note}}"
      },
      "noAssetNoNote": {
        "title": "أُخرج الأصل من الخدمة نهائيًا",
        "body": "أُخرج أحد الأصول من الخدمة نهائيًا ({{reason}}). لن يقبل فحوصات أو مهام جديدة."
      },
      "noAssetNoReason": {
        "title": "أُخرج الأصل من الخدمة نهائيًا",
        "body": "أُخرج أحد الأصول من الخدمة نهائيًا. لن يقبل فحوصات أو مهام جديدة. {{note}}"
      },
      "noAssetNoReasonNoNote": {
        "title": "أُخرج الأصل من الخدمة نهائيًا",
        "body": "أُخرج أحد الأصول من الخدمة نهائيًا. لن يقبل فحوصات أو مهام جديدة."
      },
      "default": {
        "title": "أُخرج الأصل من الخدمة نهائيًا",
        "body": "أُخرج {{asset}} من الخدمة نهائيًا ({{reason}}). لن يقبل فحوصات أو مهام جديدة. {{note}}"
      },
      "noNote": {
        "title": "أُخرج الأصل من الخدمة نهائيًا",
        "body": "أُخرج {{asset}} من الخدمة نهائيًا ({{reason}}). لن يقبل فحوصات أو مهام جديدة."
      },
      "noReason": {
        "title": "أُخرج الأصل من الخدمة نهائيًا",
        "body": "أُخرج {{asset}} من الخدمة نهائيًا. لن يقبل فحوصات أو مهام جديدة. {{note}}"
      },
      "noReasonNoNote": {
        "title": "أُخرج الأصل من الخدمة نهائيًا",
        "body": "أُخرج {{asset}} من الخدمة نهائيًا. لن يقبل فحوصات أو مهام جديدة."
      }
    },
    "asset_share_accepted": {
      "noContactNoAsset": {
        "title": "تم قبول مشاركة الأصل",
        "body": "قبلت إحدى جهات الاتصال الوصول إلى الأصل."
      },
      "noAsset": {
        "title": "تم قبول مشاركة الأصل",
        "body": "قبل {{contact}} الوصول إلى الأصل."
      },
      "noContact": {
        "title": "تم قبول مشاركة الأصل",
        "body": "قبلت إحدى جهات الاتصال الوصول إلى {{asset}}."
      },
      "default": {
        "title": "تم قبول مشاركة الأصل",
        "body": "قبل {{contact}} الوصول إلى {{asset}}."
      }
    },
    "asset_share_declined": {
      "noContactNoAsset": {
        "title": "تم رفض مشاركة الأصل",
        "body": "رفضت إحدى جهات الاتصال الوصول إلى الأصل."
      },
      "noAsset": {
        "title": "تم رفض مشاركة الأصل",
        "body": "رفض {{contact}} الوصول إلى الأصل."
      },
      "noContact": {
        "title": "تم رفض مشاركة الأصل",
        "body": "رفضت إحدى جهات الاتصال الوصول إلى {{asset}}."
      },
      "default": {
        "title": "تم رفض مشاركة الأصل",
        "body": "رفض {{contact}} الوصول إلى {{asset}}."
      }
    },
    "asset_share_ended": {
      "noAsset": {
        "title": "أُخرج الأصل المشترك من الخدمة نهائيًا",
        "body": "أخرج المالك أحد الأصول من الخدمة نهائيًا، لذا انتهى وصولك إليه. يبقى كل ما أبلغت عنه بشأنه في سجلات المالك."
      },
      "default": {
        "title": "أُخرج الأصل المشترك من الخدمة نهائيًا",
        "body": "أخرج المالك {{asset}} من الخدمة نهائيًا، لذا انتهى وصولك إليه. يبقى كل ما أبلغت عنه بشأنه في سجلات المالك."
      }
    },
    "asset_team_assigned": {
      "noTeam": {
        "title": "أصل جديد في فريقك",
        "body": "تم تعيين {{asset}} لفريقك."
      },
      "default": {
        "title": "أصل جديد في فريقك",
        "body": "تم تعيين {{asset}} لـ {{team}}."
      }
    },
    "asset_team_removed": {
      "default": {
        "title": "نُقل أصل من فريقك",
        "body": "لم يعد {{asset}} معيّنًا لفريقك."
      }
    },
    "automation_notice": {
      "default": {
        "title": "{{title}}",
        "body": "{{body}}"
      }
    },
    "completion_submitted": {
      "requesterFirstNoActorNoJobNoRequesterLegacy": {
        "title": "اكتملت المهمة — يؤكّد مقدّم الطلب أولًا",
        "body": "أكمل أحد الزملاء مهمة. يؤكّد مقدّم الطلب الإصلاح أولًا، ثم تتحقق أنت."
      },
      "requesterFirstNoActorNoJobNoRequester": {
        "title": "اكتملت المهمة — يؤكّد مقدّم الطلب أولًا",
        "body": "أكمل أحد الزملاء مهمة. يؤكّد مقدّم الطلب الإصلاح أولًا، ثم تتحقق أنت."
      },
      "requesterFirstNoActorNoRequester": {
        "title": "اكتملت المهمة — يؤكّد مقدّم الطلب أولًا",
        "body": "أكمل أحد الزملاء «{{job}}». يؤكّد مقدّم الطلب الإصلاح أولًا، ثم تتحقق أنت."
      },
      "requesterFirstNoJobNoRequesterLegacy": {
        "title": "اكتملت المهمة — يؤكّد مقدّم الطلب أولًا",
        "body": "أكمل {{actor}} مهمة. يؤكّد مقدّم الطلب الإصلاح أولًا، ثم تتحقق أنت."
      },
      "requesterFirstNoJobNoRequester": {
        "title": "اكتملت المهمة — يؤكّد مقدّم الطلب أولًا",
        "body": "أكمل {{actor}} مهمة. يؤكّد مقدّم الطلب الإصلاح أولًا، ثم تتحقق أنت."
      },
      "requesterFirstNoActorNoJobLegacy": {
        "title": "اكتملت المهمة — يؤكّد مقدّم الطلب أولًا",
        "body": "أكمل أحد الزملاء مهمة. يؤكّد {{requester}} الإصلاح أولًا، ثم تتحقق أنت."
      },
      "requesterFirstNoActorNoJob": {
        "title": "اكتملت المهمة — يؤكّد مقدّم الطلب أولًا",
        "body": "أكمل أحد الزملاء مهمة. يؤكّد {{requester}} الإصلاح أولًا، ثم تتحقق أنت."
      },
      "requesterFirstNoRequester": {
        "title": "اكتملت المهمة — يؤكّد مقدّم الطلب أولًا",
        "body": "أكمل {{actor}} «{{job}}». يؤكّد مقدّم الطلب الإصلاح أولًا، ثم تتحقق أنت."
      },
      "requesterFirstNoActor": {
        "title": "اكتملت المهمة — يؤكّد مقدّم الطلب أولًا",
        "body": "أكمل أحد الزملاء «{{job}}». يؤكّد {{requester}} الإصلاح أولًا، ثم تتحقق أنت."
      },
      "requesterFirstNoJobLegacy": {
        "title": "اكتملت المهمة — يؤكّد مقدّم الطلب أولًا",
        "body": "أكمل {{actor}} مهمة. يؤكّد {{requester}} الإصلاح أولًا، ثم تتحقق أنت."
      },
      "requesterFirstNoJob": {
        "title": "اكتملت المهمة — يؤكّد مقدّم الطلب أولًا",
        "body": "أكمل {{actor}} مهمة. يؤكّد {{requester}} الإصلاح أولًا، ثم تتحقق أنت."
      },
      "requesterFirst": {
        "title": "اكتملت المهمة — يؤكّد مقدّم الطلب أولًا",
        "body": "أكمل {{actor}} «{{job}}». يؤكّد {{requester}} الإصلاح أولًا، ثم تتحقق أنت."
      },
      "forApprovalSelf": {
        "title": "إنجازك جاهز للتحقق",
        "body": "لقد أنجزت \"{{job}}\". تحقّق منه لإغلاق المهمة."
      },
      "forApprovalSelfNoJob": {
        "title": "إنجازك جاهز للتحقق",
        "body": "لقد أنجزت مهمة. تحقّق منها لإغلاقها."
      },
      "forApprovalNoActorNoJobLegacy": {
        "title": "أُرسل إنجاز المهمة للموافقة",
        "body": "أكمل أحد الزملاء مهمة. راجعها ووافق عليها."
      },
      "forApprovalNoActorNoJob": {
        "title": "أُرسل إنجاز المهمة للموافقة",
        "body": "أكمل أحد الزملاء مهمة. راجعها ووافق عليها."
      },
      "forApprovalNoActor": {
        "title": "أُرسل إنجاز المهمة للموافقة",
        "body": "أكمل أحد الزملاء «{{job}}». راجعها ووافق عليها."
      },
      "forApprovalNoJobLegacy": {
        "title": "أُرسل إنجاز المهمة للموافقة",
        "body": "أكمل {{actor}} مهمة. راجعها ووافق عليها."
      },
      "forApprovalNoJob": {
        "title": "أُرسل إنجاز المهمة للموافقة",
        "body": "أكمل {{actor}} مهمة. راجعها ووافق عليها."
      },
      "forApproval": {
        "title": "أُرسل إنجاز المهمة للموافقة",
        "body": "أكمل {{actor}} «{{job}}». راجعها ووافق عليها."
      }
    },
    "document_expiring": {
      "certificateNoDocument": {
        "title": "شهادة تنتهي صلاحيتها قريبًا",
        "body": "تنتهي صلاحية مستند · {{asset}} في {{expiryDate}}."
      },
      "certificateNoDocumentNoAsset": {
        "title": "شهادة تنتهي صلاحيتها قريبًا",
        "body": "تنتهي صلاحية مستند في {{expiryDate}}."
      },
      "documentNoDocument": {
        "title": "مستند تنتهي صلاحيته قريبًا",
        "body": "تنتهي صلاحية مستند · {{asset}} في {{expiryDate}}."
      },
      "documentNoDocumentNoAsset": {
        "title": "مستند تنتهي صلاحيته قريبًا",
        "body": "تنتهي صلاحية مستند في {{expiryDate}}."
      },
      "certificate": {
        "title": "شهادة تنتهي صلاحيتها قريبًا",
        "body": "تنتهي صلاحية {{document}} · {{asset}} في {{expiryDate}}."
      },
      "certificateNoAsset": {
        "title": "شهادة تنتهي صلاحيتها قريبًا",
        "body": "تنتهي صلاحية {{document}} في {{expiryDate}}."
      },
      "document": {
        "title": "مستند تنتهي صلاحيته قريبًا",
        "body": "تنتهي صلاحية {{document}} · {{asset}} في {{expiryDate}}."
      },
      "documentNoAsset": {
        "title": "مستند تنتهي صلاحيته قريبًا",
        "body": "تنتهي صلاحية {{document}} في {{expiryDate}}."
      }
    },
    "document_rejected": {
      "noValidatorNoAsset": {
        "title": "رُفض المستند",
        "body": "رفض مسؤول التصديق «{{document}}» لأحد الأصول. السبب: {{reason}}"
      },
      "noValidator": {
        "title": "رُفض المستند",
        "body": "رفض مسؤول التصديق «{{document}}» لـ {{asset}}. السبب: {{reason}}"
      },
      "noValidatorNoAssetNoReason": {
        "title": "رُفض المستند",
        "body": "رفض مسؤول التصديق «{{document}}» لأحد الأصول."
      },
      "noAsset": {
        "title": "رُفض المستند",
        "body": "رفض {{validator}} «{{document}}» لأحد الأصول. السبب: {{reason}}"
      },
      "noValidatorNoReason": {
        "title": "رُفض المستند",
        "body": "رفض مسؤول التصديق «{{document}}» لـ {{asset}}."
      },
      "default": {
        "title": "رُفض المستند",
        "body": "رفض {{validator}} «{{document}}» لـ {{asset}}. السبب: {{reason}}"
      },
      "noAssetNoReason": {
        "title": "رُفض المستند",
        "body": "رفض {{validator}} «{{document}}» لأحد الأصول."
      },
      "noReason": {
        "title": "رُفض المستند",
        "body": "رفض {{validator}} «{{document}}» لـ {{asset}}."
      }
    },
    "document_validated": {
      "noValidatorNoAsset": {
        "title": "تم تصديق المستند",
        "body": "صدّق مسؤول التصديق «{{document}}» لأحد الأصول."
      },
      "noValidator": {
        "title": "تم تصديق المستند",
        "body": "صدّق مسؤول التصديق «{{document}}» لـ {{asset}}."
      },
      "noAsset": {
        "title": "تم تصديق المستند",
        "body": "صدّق {{validator}} «{{document}}» لأحد الأصول."
      },
      "default": {
        "title": "تم تصديق المستند",
        "body": "صدّق {{validator}} «{{document}}» لـ {{asset}}."
      }
    },
    "document_validation_requested": {
      "reminderNoRequesterNoAsset": {
        "title": "تذكير: صدّق «{{document}}»",
        "body": "ذكّرك أحد الزملاء بتصديق {{documentType}} لأحد الأصول (تاريخ الانتهاء {{expiryDate}})."
      },
      "reminderNoRequester": {
        "title": "تذكير: صدّق «{{document}}»",
        "body": "ذكّرك أحد الزملاء بتصديق {{documentType}} لـ {{asset}} (تاريخ الانتهاء {{expiryDate}})."
      },
      "reminderNoAsset": {
        "title": "تذكير: صدّق «{{document}}»",
        "body": "ذكّرك {{requester}} بتصديق {{documentType}} لأحد الأصول (تاريخ الانتهاء {{expiryDate}})."
      },
      "reminderNoRequesterNoAssetNoExpiry": {
        "title": "تذكير: صدّق «{{document}}»",
        "body": "ذكّرك أحد الزملاء بتصديق {{documentType}} لأحد الأصول."
      },
      "requestNoRequesterNoAsset": {
        "title": "صدّق «{{document}}»",
        "body": "طلب منك أحد الزملاء تصديق {{documentType}} لأحد الأصول (تاريخ الانتهاء {{expiryDate}})."
      },
      "reminder": {
        "title": "تذكير: صدّق «{{document}}»",
        "body": "ذكّرك {{requester}} بتصديق {{documentType}} لـ {{asset}} (تاريخ الانتهاء {{expiryDate}})."
      },
      "reminderNoRequesterNoExpiry": {
        "title": "تذكير: صدّق «{{document}}»",
        "body": "ذكّرك أحد الزملاء بتصديق {{documentType}} لـ {{asset}}."
      },
      "requestNoRequester": {
        "title": "صدّق «{{document}}»",
        "body": "طلب منك أحد الزملاء تصديق {{documentType}} لـ {{asset}} (تاريخ الانتهاء {{expiryDate}})."
      },
      "reminderNoAssetNoExpiry": {
        "title": "تذكير: صدّق «{{document}}»",
        "body": "ذكّرك {{requester}} بتصديق {{documentType}} لأحد الأصول."
      },
      "requestNoAsset": {
        "title": "صدّق «{{document}}»",
        "body": "طلب منك {{requester}} تصديق {{documentType}} لأحد الأصول (تاريخ الانتهاء {{expiryDate}})."
      },
      "requestNoRequesterNoAssetNoExpiry": {
        "title": "صدّق «{{document}}»",
        "body": "طلب منك أحد الزملاء تصديق {{documentType}} لأحد الأصول."
      },
      "reminderNoExpiry": {
        "title": "تذكير: صدّق «{{document}}»",
        "body": "ذكّرك {{requester}} بتصديق {{documentType}} لـ {{asset}}."
      },
      "request": {
        "title": "صدّق «{{document}}»",
        "body": "طلب منك {{requester}} تصديق {{documentType}} لـ {{asset}} (تاريخ الانتهاء {{expiryDate}})."
      },
      "requestNoRequesterNoExpiry": {
        "title": "صدّق «{{document}}»",
        "body": "طلب منك أحد الزملاء تصديق {{documentType}} لـ {{asset}}."
      },
      "requestNoAssetNoExpiry": {
        "title": "صدّق «{{document}}»",
        "body": "طلب منك {{requester}} تصديق {{documentType}} لأحد الأصول."
      },
      "requestNoExpiry": {
        "title": "صدّق «{{document}}»",
        "body": "طلب منك {{requester}} تصديق {{documentType}} لـ {{asset}}."
      },
      "uploadedByYou": {
        "title": "صدّق «{{document}}»",
        "body": "لقد رفعت {{documentType}} لـ {{asset}} (تاريخ الانتهاء {{expiryDate}})."
      },
      "uploadedByColleague": {
        "title": "صدّق «{{document}}»",
        "body": "رفع أحد الزملاء {{documentType}} لـ {{asset}} (تاريخ الانتهاء {{expiryDate}})."
      },
      "uploaded": {
        "title": "صدّق «{{document}}»",
        "body": "رفع {{uploader}} {{documentType}} لـ {{asset}} (تاريخ الانتهاء {{expiryDate}})."
      },
      "uploadedByYouNoExpiry": {
        "title": "صدّق «{{document}}»",
        "body": "لقد رفعت {{documentType}} لـ {{asset}}."
      },
      "uploadedByColleagueNoExpiry": {
        "title": "صدّق «{{document}}»",
        "body": "رفع أحد الزملاء {{documentType}} لـ {{asset}}."
      },
      "uploadedNoExpiry": {
        "title": "صدّق «{{document}}»",
        "body": "رفع {{uploader}} {{documentType}} لـ {{asset}}."
      }
    },
    "draft_created": {
      "noAssetLegacy": {
        "title": "تم إنشاء مسودة فحص",
        "body": "الفحص المجدول لأصل - {{template}} جاهز للإكمال."
      },
      "noAsset": {
        "title": "تم إنشاء مسودة فحص",
        "body": "الفحص المجدول لأصل - {{template}} جاهز للإكمال."
      },
      "default": {
        "title": "تم إنشاء مسودة فحص",
        "body": "الفحص المجدول لـ {{asset}} - {{template}} جاهز للإكمال."
      }
    },
    "evidence_requested": {
      "noActorNoJobLegacy": {
        "title": "مطلوب مزيد من الأدلة على مهمتك",
        "body": "طلب المراجِع مزيدًا من الأدلة على مهمة. {{reason}}"
      },
      "noActorNoJob": {
        "title": "مطلوب مزيد من الأدلة على مهمتك",
        "body": "طلب المراجِع مزيدًا من الأدلة على مهمة. {{reason}}"
      },
      "noActorNoJobNoReasonLegacy": {
        "title": "مطلوب مزيد من الأدلة على مهمتك",
        "body": "طلب المراجِع مزيدًا من الأدلة على مهمة."
      },
      "noActorNoJobNoReason": {
        "title": "مطلوب مزيد من الأدلة على مهمتك",
        "body": "طلب المراجِع مزيدًا من الأدلة على مهمة."
      },
      "noActor": {
        "title": "مطلوب مزيد من الأدلة على مهمتك",
        "body": "طلب المراجِع مزيدًا من الأدلة على «{{job}}». {{reason}}"
      },
      "noActorNoReason": {
        "title": "مطلوب مزيد من الأدلة على مهمتك",
        "body": "طلب المراجِع مزيدًا من الأدلة على «{{job}}»."
      },
      "noJobLegacy": {
        "title": "مطلوب مزيد من الأدلة على مهمتك",
        "body": "طلب {{actor}} مزيدًا من الأدلة على مهمة. {{reason}}"
      },
      "noJob": {
        "title": "مطلوب مزيد من الأدلة على مهمتك",
        "body": "طلب {{actor}} مزيدًا من الأدلة على مهمة. {{reason}}"
      },
      "noJobNoReasonLegacy": {
        "title": "مطلوب مزيد من الأدلة على مهمتك",
        "body": "طلب {{actor}} مزيدًا من الأدلة على مهمة."
      },
      "noJobNoReason": {
        "title": "مطلوب مزيد من الأدلة على مهمتك",
        "body": "طلب {{actor}} مزيدًا من الأدلة على مهمة."
      },
      "default": {
        "title": "مطلوب مزيد من الأدلة على مهمتك",
        "body": "طلب {{actor}} مزيدًا من الأدلة على «{{job}}». {{reason}}"
      },
      "noReason": {
        "title": "مطلوب مزيد من الأدلة على مهمتك",
        "body": "طلب {{actor}} مزيدًا من الأدلة على «{{job}}»."
      }
    },
    "free_period_ending": {
      "ended": {
        "title": "انتهت فترتك المجانية",
        "body": "مساحة عملك الآن للقراءة فقط. اختر خطة لمواصلة العمل. لم يُحذف أي شيء."
      },
      "tomorrow": {
        "title": "تنتهي فترتك المجانية غدًا",
        "body": "اختر خطة قبل {{endDate}} لمواصلة الإضافة والتعديل. لن يُحذف أي شيء في كلتا الحالتين."
      },
      "inDays": {
        "title": "تنتهي فترتك المجانية خلال {{daysLeft}} يوم",
        "body": "اختر خطة قبل {{endDate}} لمواصلة الإضافة والتعديل. لن يُحذف أي شيء في كلتا الحالتين."
      }
    },
    "inspection_approved": {
      "noActorNoAsset": {
        "title": "تمت الموافقة على فحصك",
        "body": "وافق المعتمِد على فحصك لأحد الأصول."
      },
      "noActor": {
        "title": "تمت الموافقة على فحصك",
        "body": "وافق المعتمِد على فحصك لـ {{asset}}."
      },
      "noAsset": {
        "title": "تمت الموافقة على فحصك",
        "body": "وافق {{actor}} على فحصك لأحد الأصول."
      },
      "default": {
        "title": "تمت الموافقة على فحصك",
        "body": "وافق {{actor}} على فحصك لـ {{asset}}."
      }
    },
    "inspection_assigned": {
      "scheduledByActorNoTemplateNoAsset": {
        "title": "تم تكليفك بفحص",
        "body": "كلّفك {{actor}} بفحص لأحد الأصول · {{when}}."
      },
      "byActorNoTemplateNoAsset": {
        "title": "تم تكليفك بفحص",
        "body": "كلّفك {{actor}} بفحص لأحد الأصول."
      },
      "scheduledByActorNoTemplate": {
        "title": "تم تكليفك بفحص",
        "body": "كلّفك {{actor}} بفحص لـ {{asset}} · {{when}}."
      },
      "byActorNoTemplate": {
        "title": "تم تكليفك بفحص",
        "body": "كلّفك {{actor}} بفحص لـ {{asset}}."
      },
      "scheduledByActorNoAsset": {
        "title": "تم تكليفك بفحص",
        "body": "كلّفك {{actor}} بـ «{{template}}» لأحد الأصول · {{when}}."
      },
      "byActorNoAsset": {
        "title": "تم تكليفك بفحص",
        "body": "كلّفك {{actor}} بـ «{{template}}» لأحد الأصول."
      },
      "scheduledNoTemplateNoAsset": {
        "title": "تم تكليفك بفحص",
        "body": "فحص · أصل · {{when}}."
      },
      "scheduledByActor": {
        "title": "تم تكليفك بفحص",
        "body": "كلّفك {{actor}} بـ «{{template}}» لـ {{asset}} · {{when}}."
      },
      "noTemplateNoAsset": {
        "title": "تم تكليفك بفحص",
        "body": "فحص · أصل."
      },
      "byActor": {
        "title": "تم تكليفك بفحص",
        "body": "كلّفك {{actor}} بـ «{{template}}» لـ {{asset}}."
      },
      "scheduledNoTemplate": {
        "title": "تم تكليفك بفحص",
        "body": "فحص · {{asset}} · {{when}}."
      },
      "scheduledNoAsset": {
        "title": "تم تكليفك بفحص",
        "body": "{{template}} · أصل · {{when}}."
      },
      "noTemplate": {
        "title": "تم تكليفك بفحص",
        "body": "فحص · {{asset}}."
      },
      "noAsset": {
        "title": "تم تكليفك بفحص",
        "body": "{{template}} · أصل."
      },
      "scheduled": {
        "title": "تم تكليفك بفحص",
        "body": "{{template}} · {{asset}} · {{when}}."
      },
      "default": {
        "title": "تم تكليفك بفحص",
        "body": "{{template}} · {{asset}}."
      }
    },
    "inspection_completed_for_approval": {
      "noActorNoAsset": {
        "title": "فحص جاهز لموافقتك",
        "body": "أكمل أحد الزملاء فحصًا لأحد الأصول. راجعه ووافق عليه."
      },
      "noActor": {
        "title": "فحص جاهز لموافقتك",
        "body": "أكمل أحد الزملاء فحصًا لـ {{asset}}. راجعه ووافق عليه."
      },
      "noAsset": {
        "title": "فحص جاهز لموافقتك",
        "body": "أكمل {{actor}} فحصًا لأحد الأصول. راجعه ووافق عليه."
      },
      "default": {
        "title": "فحص جاهز لموافقتك",
        "body": "أكمل {{actor}} فحصًا لـ {{asset}}. راجعه ووافق عليه."
      }
    },
    "inspection_reassigned": {
      "inspectionNoAsset": {
        "title": "أُعيد تكليف الفحص",
        "body": "لم تعد مكلّفًا بفحص هذا الأصل."
      },
      "inspection": {
        "title": "أُعيد تكليف الفحص",
        "body": "لم تعد مكلّفًا بفحص {{asset}}."
      },
      "scheduleNoAsset": {
        "title": "أُعيد تكليف الفحص",
        "body": "لم تعد مكلّفًا بهذا الفحص."
      },
      "schedule": {
        "title": "أُعيد تكليف الفحص",
        "body": "لم تعد مكلّفًا بـ {{asset}}."
      }
    },
    "inspection_reopened": {
      "noActorNoAsset": {
        "title": "أُعيد فتح فحصك",
        "body": "أعاد أحد الزملاء فتح فحصك لأحد الأصول."
      },
      "noActor": {
        "title": "أُعيد فتح فحصك",
        "body": "أعاد أحد الزملاء فتح فحصك لـ {{asset}}."
      },
      "noAsset": {
        "title": "أُعيد فتح فحصك",
        "body": "أعاد {{actor}} فتح فحصك لأحد الأصول."
      },
      "default": {
        "title": "أُعيد فتح فحصك",
        "body": "أعاد {{actor}} فتح فحصك لـ {{asset}}."
      }
    },
    "inspection_report_shared": {
      "recipientNoSharerNoAsset": {
        "title": "تقرير الفحص جاهز",
        "body": "شارك المفتّش تقرير الفحص لأحد الأصول. راجعه ووقّع عليه."
      },
      "recipientNoSharer": {
        "title": "تقرير الفحص جاهز",
        "body": "شارك المفتّش تقرير الفحص لـ {{asset}}. راجعه ووقّع عليه."
      },
      "recipientNoAsset": {
        "title": "تقرير الفحص جاهز",
        "body": "شارك {{sharer}} تقرير الفحص لأحد الأصول. راجعه ووقّع عليه."
      },
      "recipient": {
        "title": "تقرير الفحص جاهز",
        "body": "شارك {{sharer}} تقرير الفحص لـ {{asset}}. راجعه ووقّع عليه."
      },
      "sharerNoRecipient": {
        "title": "تمت مشاركة تقرير الفحص",
        "body": "رابط المراجعة جاهز للمستلم."
      },
      "resentNoRecipient": {
        "title": "أُعيد إرسال تقرير الفحص",
        "body": "أُرسل مرة أخرى إلى المستلم."
      },
      "sharer": {
        "title": "تمت مشاركة تقرير الفحص",
        "body": "رابط المراجعة جاهز لـ {{recipient}}."
      },
      "sharerBlankName": {
        "title": "تمت مشاركة تقرير الفحص",
        "body": "رابط المراجعة جاهز."
      },
      "resentBlankName": {
        "title": "أُعيد إرسال تقرير الفحص",
        "body": "تم تحديث رابط التقرير."
      },
      "resent": {
        "title": "أُعيد إرسال تقرير الفحص",
        "body": "أُرسل مرة أخرى إلى {{recipient}}."
      }
    },
    "inspection_sent_back": {
      "noActorNoAsset": {
        "title": "أُعيد فحصك إليك",
        "body": "أعاد المعتمِد فحصك لأحد الأصول: {{reason}}"
      },
      "noActor": {
        "title": "أُعيد فحصك إليك",
        "body": "أعاد المعتمِد فحصك لـ {{asset}}: {{reason}}"
      },
      "noAsset": {
        "title": "أُعيد فحصك إليك",
        "body": "أعاد {{actor}} فحصك لأحد الأصول: {{reason}}"
      },
      "default": {
        "title": "أُعيد فحصك إليك",
        "body": "أعاد {{actor}} فحصك لـ {{asset}}: {{reason}}"
      }
    },
    "inspection_unassigned": {
      "inspectionNoAsset": {
        "title": "أُلغي تكليف الفحص",
        "body": "لم تعد مكلّفًا بفحص هذا الأصل."
      },
      "inspection": {
        "title": "أُلغي تكليف الفحص",
        "body": "لم تعد مكلّفًا بفحص {{asset}}."
      },
      "scheduleNoAsset": {
        "title": "أُلغي تكليف الفحص",
        "body": "لم تعد مكلّفًا بهذا الفحص."
      },
      "schedule": {
        "title": "أُلغي تكليف الفحص",
        "body": "لم تعد مكلّفًا بـ {{asset}}."
      }
    },
    "inspection_visit_proposed": {
      "noInspection": {
        "title": "أكّد موعد الزيارة",
        "body": "فحص مخطط له في {{when}} — أكّد أن أحدًا يمكنه الحضور، أو اطلب وقتًا مختلفًا."
      },
      "default": {
        "title": "أكّد موعد الزيارة",
        "body": "{{inspection}} مخطط له في {{when}} — أكّد أن أحدًا يمكنه الحضور، أو اطلب وقتًا مختلفًا."
      }
    },
    "job_accepted": {
      "noActorNoJobLegacy": {
        "title": "تم قبول المهمة",
        "body": "قبِل المكلَّف مهمة."
      },
      "noActorNoJob": {
        "title": "تم قبول المهمة",
        "body": "قبِل المكلَّف مهمة."
      },
      "noActor": {
        "title": "تم قبول المهمة",
        "body": "قبِل المكلَّف «{{job}}»."
      },
      "noJobLegacy": {
        "title": "تم قبول المهمة",
        "body": "قبِل {{actor}} مهمة."
      },
      "noJob": {
        "title": "تم قبول المهمة",
        "body": "قبِل {{actor}} مهمة."
      },
      "default": {
        "title": "تم قبول المهمة",
        "body": "قبِل {{actor}} «{{job}}»."
      }
    },
    "job_approver_assigned": {
      "noJob": {
        "title": "تم إسناد مسؤولية الموافقة",
        "body": "ستحتاج إحدى المهام إلى مراجعتك."
      },
      "default": {
        "title": "تم إسناد مسؤولية الموافقة",
        "body": "ستحتاج المهمة {{job}} إلى مراجعتك."
      }
    },
    "job_approver_removed": {
      "noJobLegacy": {
        "title": "تغيّرت مسؤولية الموافقة",
        "body": "لم تعد معتمِدًا لإحدى المهام."
      },
      "noJob": {
        "title": "تغيّرت مسؤولية الموافقة",
        "body": "لم تعد معتمِدًا لإحدى المهام."
      },
      "default": {
        "title": "تغيّرت مسؤولية الموافقة",
        "body": "لم تعد معتمِدًا لـ {{job}}."
      }
    },
    "job_assigned": {
      "byActorNoJobLegacy": {
        "title": "تم تكليفك بمهمة",
        "body": "كلّفك {{actor}} بمهمة · {{asset}} · مستحقة في {{dueDate}}."
      },
      "byActorNoJob": {
        "title": "تم تكليفك بمهمة",
        "body": "كلّفك {{actor}} بمهمة · {{asset}} · مستحقة في {{dueDate}}."
      },
      "byActorNoJobNoAssetLegacy": {
        "title": "تم تكليفك بمهمة",
        "body": "كلّفك {{actor}} بمهمة · مستحقة في {{dueDate}}."
      },
      "byActorNoJobNoAsset": {
        "title": "تم تكليفك بمهمة",
        "body": "كلّفك {{actor}} بمهمة · مستحقة في {{dueDate}}."
      },
      "byActor": {
        "title": "تم تكليفك بمهمة",
        "body": "كلّفك {{actor}} بـ «{{job}}» · {{asset}} · مستحقة في {{dueDate}}."
      },
      "byActorNoJobNoDueLegacy": {
        "title": "تم تكليفك بمهمة",
        "body": "كلّفك {{actor}} بمهمة · {{asset}}."
      },
      "byActorNoJobNoDue": {
        "title": "تم تكليفك بمهمة",
        "body": "كلّفك {{actor}} بمهمة · {{asset}}."
      },
      "byActorNoAsset": {
        "title": "تم تكليفك بمهمة",
        "body": "كلّفك {{actor}} بـ «{{job}}» · مستحقة في {{dueDate}}."
      },
      "byActorNoJobNoAssetNoDueLegacy": {
        "title": "تم تكليفك بمهمة",
        "body": "كلّفك {{actor}} بمهمة."
      },
      "byActorNoJobNoAssetNoDue": {
        "title": "تم تكليفك بمهمة",
        "body": "كلّفك {{actor}} بمهمة."
      },
      "byActorNoDue": {
        "title": "تم تكليفك بمهمة",
        "body": "كلّفك {{actor}} بـ «{{job}}» · {{asset}}."
      },
      "byActorNoAssetNoDue": {
        "title": "تم تكليفك بمهمة",
        "body": "كلّفك {{actor}} بـ «{{job}}»."
      },
      "noJob": {
        "title": "تم تكليفك بمهمة",
        "body": "مهمة · {{asset}} · مستحقة في {{dueDate}}."
      },
      "noJobNoAsset": {
        "title": "تم تكليفك بمهمة",
        "body": "مهمة · مستحقة في {{dueDate}}."
      },
      "default": {
        "title": "تم تكليفك بمهمة",
        "body": "{{job}} · {{asset}} · مستحقة في {{dueDate}}."
      },
      "noJobNoDue": {
        "title": "تم تكليفك بمهمة",
        "body": "مهمة · {{asset}}."
      },
      "noAsset": {
        "title": "تم تكليفك بمهمة",
        "body": "{{job}} · مستحقة في {{dueDate}}."
      },
      "noJobNoAssetNoDue": {
        "title": "تم تكليفك بمهمة",
        "body": "مهمة."
      },
      "noDue": {
        "title": "تم تكليفك بمهمة",
        "body": "{{job}} · {{asset}}."
      },
      "noAssetNoDue": {
        "title": "تم تكليفك بمهمة",
        "body": "{{job}}."
      }
    },
    "job_cancelled": {
      "noActorNoJobLegacy": {
        "title": "تم إلغاء المهمة",
        "body": "ألغى أحد الزملاء مهمة لـ {{asset}}."
      },
      "noActorNoJob": {
        "title": "تم إلغاء المهمة",
        "body": "ألغى أحد الزملاء مهمة لـ {{asset}}."
      },
      "noActorNoJobNoAssetLegacy": {
        "title": "تم إلغاء المهمة",
        "body": "ألغى أحد الزملاء مهمة."
      },
      "noActorNoJobNoAsset": {
        "title": "تم إلغاء المهمة",
        "body": "ألغى أحد الزملاء مهمة."
      },
      "noActor": {
        "title": "تم إلغاء المهمة",
        "body": "ألغى أحد الزملاء «{{job}}» لـ {{asset}}."
      },
      "noActorNoAsset": {
        "title": "تم إلغاء المهمة",
        "body": "ألغى أحد الزملاء «{{job}}»."
      },
      "noJobLegacy": {
        "title": "تم إلغاء المهمة",
        "body": "ألغى {{actor}} مهمة لـ {{asset}}."
      },
      "noJob": {
        "title": "تم إلغاء المهمة",
        "body": "ألغى {{actor}} مهمة لـ {{asset}}."
      },
      "noJobNoAssetLegacy": {
        "title": "تم إلغاء المهمة",
        "body": "ألغى {{actor}} مهمة."
      },
      "noJobNoAsset": {
        "title": "تم إلغاء المهمة",
        "body": "ألغى {{actor}} مهمة."
      },
      "default": {
        "title": "تم إلغاء المهمة",
        "body": "ألغى {{actor}} «{{job}}» لـ {{asset}}."
      },
      "noAsset": {
        "title": "تم إلغاء المهمة",
        "body": "ألغى {{actor}} «{{job}}»."
      }
    },
    "job_completion_approved": {
      "noRequesterNoJob": {
        "title": "تمت الموافقة على الإنجاز",
        "body": "وافق مقدّم الطلب على إنجاز المهمة."
      },
      "noRequester": {
        "title": "تمت الموافقة على الإنجاز",
        "body": "وافق مقدّم الطلب على إنجاز {{job}}."
      },
      "noJob": {
        "title": "تمت الموافقة على الإنجاز",
        "body": "وافق {{requester}} على إنجاز المهمة."
      },
      "default": {
        "title": "تمت الموافقة على الإنجاز",
        "body": "وافق {{requester}} على إنجاز {{job}}."
      }
    },
    "job_declined": {
      "noActorNoJobLegacy": {
        "title": "رُفضت المهمة — أعد تكليفها",
        "body": "رفض المكلَّف مهمة. السبب: {{reason}}. كلّف بها شخصًا آخر لتستمر."
      },
      "noActorNoJob": {
        "title": "رُفضت المهمة — أعد تكليفها",
        "body": "رفض المكلَّف مهمة. السبب: {{reason}} كلّف بها شخصًا آخر لتستمر."
      },
      "noActor": {
        "title": "رُفضت المهمة — أعد تكليفها",
        "body": "رفض المكلَّف «{{job}}». السبب: {{reason}} كلّف بها شخصًا آخر لتستمر."
      },
      "noActorNoJobNoReasonLegacy": {
        "title": "رُفضت المهمة — أعد تكليفها",
        "body": "رفض المكلَّف مهمة. كلّف بها شخصًا آخر لتستمر."
      },
      "noActorNoJobNoReason": {
        "title": "رُفضت المهمة — أعد تكليفها",
        "body": "رفض المكلَّف مهمة. كلّف بها شخصًا آخر لتستمر."
      },
      "noJobLegacy": {
        "title": "رُفضت المهمة — أعد تكليفها",
        "body": "رفض {{actor}} مهمة. السبب: {{reason}}. كلّف بها شخصًا آخر لتستمر."
      },
      "noJob": {
        "title": "رُفضت المهمة — أعد تكليفها",
        "body": "رفض {{actor}} مهمة. السبب: {{reason}} كلّف بها شخصًا آخر لتستمر."
      },
      "noActorNoReason": {
        "title": "رُفضت المهمة — أعد تكليفها",
        "body": "رفض المكلَّف «{{job}}». كلّف بها شخصًا آخر لتستمر."
      },
      "default": {
        "title": "رُفضت المهمة — أعد تكليفها",
        "body": "رفض {{actor}} «{{job}}». السبب: {{reason}} كلّف بها شخصًا آخر لتستمر."
      },
      "noJobNoReasonLegacy": {
        "title": "رُفضت المهمة — أعد تكليفها",
        "body": "رفض {{actor}} مهمة. كلّف بها شخصًا آخر لتستمر."
      },
      "noJobNoReason": {
        "title": "رُفضت المهمة — أعد تكليفها",
        "body": "رفض {{actor}} مهمة. كلّف بها شخصًا آخر لتستمر."
      },
      "noReason": {
        "title": "رُفضت المهمة — أعد تكليفها",
        "body": "رفض {{actor}} «{{job}}». كلّف بها شخصًا آخر لتستمر."
      }
    },
    "job_message": {
      "photoNoSenderLegacy": {
        "title": "رسالة جديدة على مهمة.",
        "body": "شارك أحدهم صورة."
      },
      "photoNoSender": {
        "title": "رسالة جديدة على مهمة.",
        "body": "شارك أحدهم صورة."
      },
      "photoLegacy": {
        "title": "رسالة جديدة على مهمة.",
        "body": "شارك {{sender}} صورة."
      },
      "photo": {
        "title": "رسالة جديدة على مهمة.",
        "body": "شارك {{sender}} صورة."
      },
      "emptyUpdateNoSender": {
        "title": "رسالة جديدة على مهمة",
        "body": "أحدهم: تحديث"
      },
      "noSender": {
        "title": "رسالة جديدة على مهمة",
        "body": "أحدهم: {{message}}"
      },
      "emptyUpdate": {
        "title": "رسالة جديدة على مهمة",
        "body": "{{sender}}: تحديث"
      },
      "default": {
        "title": "رسالة جديدة على مهمة",
        "body": "{{sender}}: {{message}}"
      }
    },
    "job_reassigned": {
      "noJobLegacy": {
        "title": "أُعيد تكليف المهمة",
        "body": "لم تعد مكلّفًا بإحدى المهام."
      },
      "noJob": {
        "title": "أُعيد تكليف المهمة",
        "body": "لم تعد مكلّفًا بإحدى المهام."
      },
      "default": {
        "title": "أُعيد تكليف المهمة",
        "body": "لم تعد مكلّفًا بـ {{job}}."
      }
    },
    "job_report_shared": {
      "recipientNoSharerNoJobNoAssetLegacy": {
        "title": "تقرير المهمة جاهز",
        "body": "شارك الفريق تقرير الإنجاز لمهمة على أحد الأصول."
      },
      "recipientNoSharerNoJobNoAsset": {
        "title": "تقرير المهمة جاهز",
        "body": "شارك الفريق تقرير الإنجاز لمهمة على أحد الأصول."
      },
      "recipientNoSharerNoAsset": {
        "title": "تقرير المهمة جاهز",
        "body": "شارك الفريق تقرير الإنجاز لـ «{{job}}» على أحد الأصول."
      },
      "recipientNoJobNoAssetLegacy": {
        "title": "تقرير المهمة جاهز",
        "body": "شارك {{sharer}} تقرير الإنجاز لمهمة على أحد الأصول."
      },
      "recipientNoJobNoAsset": {
        "title": "تقرير المهمة جاهز",
        "body": "شارك {{sharer}} تقرير الإنجاز لمهمة على أحد الأصول."
      },
      "recipientNoSharerNoJobLegacy": {
        "title": "تقرير المهمة جاهز",
        "body": "شارك الفريق تقرير الإنجاز لمهمة على {{asset}}."
      },
      "recipientNoSharerNoJob": {
        "title": "تقرير المهمة جاهز",
        "body": "شارك الفريق تقرير الإنجاز لمهمة على {{asset}}."
      },
      "recipientNoAsset": {
        "title": "تقرير المهمة جاهز",
        "body": "شارك {{sharer}} تقرير الإنجاز لـ «{{job}}» على أحد الأصول."
      },
      "recipientNoSharer": {
        "title": "تقرير المهمة جاهز",
        "body": "شارك الفريق تقرير الإنجاز لـ «{{job}}» على {{asset}}."
      },
      "recipientNoJobLegacy": {
        "title": "تقرير المهمة جاهز",
        "body": "شارك {{sharer}} تقرير الإنجاز لمهمة على {{asset}}."
      },
      "recipientNoJob": {
        "title": "تقرير المهمة جاهز",
        "body": "شارك {{sharer}} تقرير الإنجاز لمهمة على {{asset}}."
      },
      "sharerNoRecipient": {
        "title": "تمت مشاركة تقرير إنجاز المهمة",
        "body": "أُرسل رابط التقرير إلى المستلم."
      },
      "recipient": {
        "title": "تقرير المهمة جاهز",
        "body": "شارك {{sharer}} تقرير الإنجاز لـ «{{job}}» على {{asset}}."
      },
      "resentNoRecipient": {
        "title": "أُعيد إرسال تقرير إنجاز المهمة",
        "body": "أُرسل مرة أخرى إلى المستلم."
      },
      "sharer": {
        "title": "تمت مشاركة تقرير إنجاز المهمة",
        "body": "أُرسل رابط التقرير إلى {{recipient}}."
      },
      "sharerBlankName": {
        "title": "تمت مشاركة تقرير إنجاز المهمة",
        "body": "رابط التقرير جاهز."
      },
      "resentBlankName": {
        "title": "أُعيد إرسال تقرير إنجاز المهمة",
        "body": "تم تحديث رابط التقرير."
      },
      "resent": {
        "title": "أُعيد إرسال تقرير إنجاز المهمة",
        "body": "أُرسل مرة أخرى إلى {{recipient}}."
      }
    },
    "job_requester_accepted": {
      "verifierNoRequesterNoJob": {
        "title": "مقدّم الطلب راضٍ — تحقّق للإغلاق",
        "body": "قبِل مقدّم الطلب إنجاز المهمة. تحقّق من المهمة لإغلاقها."
      },
      "verifierNoRequester": {
        "title": "مقدّم الطلب راضٍ — تحقّق للإغلاق",
        "body": "قبِل مقدّم الطلب إنجاز {{job}}. تحقّق من المهمة لإغلاقها."
      },
      "verifierNoJob": {
        "title": "مقدّم الطلب راضٍ — تحقّق للإغلاق",
        "body": "قبِل {{requester}} إنجاز المهمة. تحقّق من المهمة لإغلاقها."
      },
      "verifier": {
        "title": "مقدّم الطلب راضٍ — تحقّق للإغلاق",
        "body": "قبِل {{requester}} إنجاز {{job}}. تحقّق من المهمة لإغلاقها."
      },
      "informedNoRequesterNoJob": {
        "title": "قبِل مقدّم الطلب العمل",
        "body": "قبِل مقدّم الطلب إنجاز المهمة."
      },
      "informedNoRequester": {
        "title": "قبِل مقدّم الطلب العمل",
        "body": "قبِل مقدّم الطلب إنجاز {{job}}."
      },
      "informedNoJob": {
        "title": "قبِل مقدّم الطلب العمل",
        "body": "قبِل {{requester}} إنجاز المهمة."
      },
      "informed": {
        "title": "قبِل مقدّم الطلب العمل",
        "body": "قبِل {{requester}} إنجاز {{job}}."
      }
    },
    "job_rework_requested": {
      "noRequesterNoJob": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب مقدّم الطلب إعادة العمل في المهمة: {{note}}"
      },
      "noRequesterNoJobNoNote": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب مقدّم الطلب إعادة العمل في المهمة."
      },
      "noRequester": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب مقدّم الطلب إعادة العمل في {{job}}: {{note}}"
      },
      "noRequesterNoNote": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب مقدّم الطلب إعادة العمل في {{job}}."
      },
      "noJob": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب {{requester}} إعادة العمل في المهمة: {{note}}"
      },
      "noJobNoNote": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب {{requester}} إعادة العمل في المهمة."
      },
      "default": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب {{requester}} إعادة العمل في {{job}}: {{note}}"
      },
      "noNote": {
        "title": "طُلبت إعادة العمل",
        "body": "طلب {{requester}} إعادة العمل في {{job}}."
      }
    },
    "job_scheduled": {
      "noActorNoJobLegacy": {
        "title": "تم تحديد موعد الزيارة",
        "body": "حدّد المكلَّف موعد مهمة في {{when}}."
      },
      "noActorNoJob": {
        "title": "تم تحديد موعد الزيارة",
        "body": "حدّد المكلَّف موعد مهمة في {{when}}."
      },
      "noActor": {
        "title": "تم تحديد موعد الزيارة",
        "body": "حدّد المكلَّف موعد «{{job}}» في {{when}}."
      },
      "noJobLegacy": {
        "title": "تم تحديد موعد الزيارة",
        "body": "حدّد {{actor}} موعد مهمة في {{when}}."
      },
      "noJob": {
        "title": "تم تحديد موعد الزيارة",
        "body": "حدّد {{actor}} موعد مهمة في {{when}}."
      },
      "default": {
        "title": "تم تحديد موعد الزيارة",
        "body": "حدّد {{actor}} موعد «{{job}}» في {{when}}."
      }
    },
    "job_unassigned": {
      "noJobLegacy": {
        "title": "أُلغي تكليف المهمة",
        "body": "لم تعد مكلّفًا بإحدى المهام."
      },
      "noJob": {
        "title": "أُلغي تكليف المهمة",
        "body": "لم تعد مكلّفًا بإحدى المهام."
      },
      "default": {
        "title": "أُلغي تكليف المهمة",
        "body": "لم تعد مكلّفًا بـ {{job}}."
      }
    },
    "job_verified": {
      "noActorNoJobLegacy": {
        "title": "تم التحقق من عملك",
        "body": "تحقّق المالك من مهمة. أُغلقت المهمة."
      },
      "noActorNoJob": {
        "title": "تم التحقق من عملك",
        "body": "تحقّق المالك من مهمة. أُغلقت المهمة."
      },
      "noActor": {
        "title": "تم التحقق من عملك",
        "body": "تحقّق المالك من «{{job}}». أُغلقت المهمة."
      },
      "noJobLegacy": {
        "title": "تم التحقق من عملك",
        "body": "تحقّق {{actor}} من مهمة. أُغلقت المهمة."
      },
      "noJob": {
        "title": "تم التحقق من عملك",
        "body": "تحقّق {{actor}} من مهمة. أُغلقت المهمة."
      },
      "default": {
        "title": "تم التحقق من عملك",
        "body": "تحقّق {{actor}} من «{{job}}». أُغلقت المهمة."
      }
    },
    "job_visit_proposed": {
      "noJob": {
        "title": "أكّد موعد الزيارة",
        "body": "مهمة مخطط لها في {{when}} — أكّد أن أحدًا يمكنه الحضور، أو اطلب وقتًا مختلفًا."
      },
      "default": {
        "title": "أكّد موعد الزيارة",
        "body": "{{job}} مخطط لها في {{when}} — أكّد أن أحدًا يمكنه الحضور، أو اطلب وقتًا مختلفًا."
      }
    },
    "mcp_action_proposed": {
      "oneNoClient": {
        "title": "طلبات من الذكاء الاصطناعي بانتظار موافقتك",
        "body": "يطلب مساعد ذكاء اصطناعي: {{action}}. وافق عليه أو ارفضه قبل انتهاء صلاحيته."
      },
      "many": {
        "title": "طلبات من الذكاء الاصطناعي بانتظار موافقتك",
        "body": "تغييرات من مساعدي الذكاء الاصطناعي بانتظار موافقتك: {{total}}."
      },
      "one": {
        "title": "طلبات من الذكاء الاصطناعي بانتظار موافقتك",
        "body": "يطلب {{client}}: {{action}}. وافق عليه أو ارفضه قبل انتهاء صلاحيته."
      }
    },
    "member_removed_reassign": {
      "noLeaverNoJobLegacy": {
        "title": "أعد تكليف العمل المتروك",
        "body": "غادر أحدهم الفريق وما زالت مهمة مكلّفة إليه. كلّف بها شخصًا آخر."
      },
      "noLeaverNoJob": {
        "title": "أعد تكليف العمل المتروك",
        "body": "غادر أحدهم الفريق وما زالت مهمة مكلّفة إليه. كلّف بها شخصًا آخر."
      },
      "noLeaver": {
        "title": "أعد تكليف العمل المتروك",
        "body": "غادر أحدهم الفريق وما زالت «{{job}}» مكلّفة إليه. كلّف بها شخصًا آخر."
      },
      "noJobLegacy": {
        "title": "أعد تكليف العمل المتروك",
        "body": "غادر {{leaver}} الفريق وما زالت مهمة مكلّفة إليه. كلّف بها شخصًا آخر."
      },
      "noJob": {
        "title": "أعد تكليف العمل المتروك",
        "body": "غادر {{leaver}} الفريق وما زالت مهمة مكلّفة إليه. كلّف بها شخصًا آخر."
      },
      "default": {
        "title": "أعد تكليف العمل المتروك",
        "body": "غادر {{leaver}} الفريق وما زالت «{{job}}» مكلّفة إليه. كلّف بها شخصًا آخر."
      }
    },
    "mfa_reset_requested": {
      "noMember": {
        "title": "طُلبت إعادة تعيين التحقق بخطوتين",
        "body": "أحد أعضاء مساحة العمل لا يستطيع إكمال التحقق بخطوتين لتسجيل الدخول وطلب إعادة تعيينه."
      },
      "default": {
        "title": "طُلبت إعادة تعيين التحقق بخطوتين",
        "body": "{{member}} لا يستطيع إكمال التحقق بخطوتين لتسجيل الدخول وطلب إعادة تعيينه."
      }
    },
    "plan_changed": {
      "byActorLegacy": {
        "title": "تغيّرت خطتك ليوم {{day}}",
        "body": "غيّر {{actor}} {{total}} عناصر في يومك. افتح «يومي» لرؤيتها."
      },
      "byActor": {
        "title": "تغيّرت خطتك ليوم {{day}}",
        "body": "غيّر {{actor}} {{total}} عناصر في يومك. افتح «يومي» لرؤيتها."
      },
      "defaultLegacy": {
        "title": "تغيّرت خطتك ليوم {{day}}",
        "body": "تم تغيير {{total}} عناصر في يومك. افتح «يومي» لرؤيتها."
      },
      "default": {
        "title": "تغيّرت خطتك ليوم {{day}}",
        "body": "تم تغيير {{total}} عناصر في يومك. افتح «يومي» لرؤيتها."
      },
      "byActorOne": {
        "title": "تغيّرت خطتك ليوم {{day}}",
        "body": "غيّر {{actor}} {{total}} عنصر في يومك. افتح «يومي» لرؤيته."
      },
      "one": {
        "title": "تغيّرت خطتك ليوم {{day}}",
        "body": "تم تغيير {{total}} عنصر في يومك. افتح «يومي» لرؤيته."
      }
    },
    "plan_review": {
      "default": {
        "title": "خطة يوم {{day}} تحتاج إلى مراجعة",
        "body": "لم يعد شيء ما في اليوم ممكنًا كما هو. افتح التقويم لمراجعة الخطة المقترحة."
      }
    },
    "quote_declined": {
      "noContractor": {
        "title": "رُفض طلب عرض السعر",
        "body": "اعتذر أحد المقاولين عن تقديم عرض سعر لـ {{job}}."
      },
      "noContractorNoJob": {
        "title": "رُفض طلب عرض السعر",
        "body": "اعتذر أحد المقاولين عن تقديم عرض سعر."
      },
      "default": {
        "title": "رُفض طلب عرض السعر",
        "body": "اعتذر {{contractor}} عن تقديم عرض سعر لـ {{job}}."
      },
      "noJob": {
        "title": "رُفض طلب عرض السعر",
        "body": "اعتذر {{contractor}} عن تقديم عرض سعر."
      }
    },
    "quote_rejected": {
      "noJobLegacy": {
        "title": "لم يتم اختيار عرض السعر",
        "body": "تمت مراجعة عرض سعرك لمهمة لكن لم يتم اختياره."
      },
      "noJob": {
        "title": "لم يتم اختيار عرض السعر",
        "body": "تمت مراجعة عرض سعرك لمهمة لكن لم يتم اختياره."
      },
      "default": {
        "title": "لم يتم اختيار عرض السعر",
        "body": "تمت مراجعة عرض سعرك لـ «{{job}}» لكن لم يتم اختياره."
      }
    },
    "quote_requested": {
      "noJobLegacy": {
        "title": "طلب عرض سعر",
        "body": "تمت دعوتك لتقديم عرض سعر لـ: مهمة."
      },
      "noJob": {
        "title": "طلب عرض سعر",
        "body": "تمت دعوتك لتقديم عرض سعر لـ: مهمة."
      },
      "default": {
        "title": "طلب عرض سعر",
        "body": "تمت دعوتك لتقديم عرض سعر لـ: {{job}}."
      }
    },
    "quote_submitted": {
      "taxNoContractorNoJob": {
        "title": "تم استلام عرض سعر جديد",
        "body": "قدّم أحد المقاولين عرض سعر بقيمة {{amount}} شاملًا الضرائب لمهمة. راجع عروض الأسعار."
      },
      "taxNoContractor": {
        "title": "تم استلام عرض سعر جديد",
        "body": "قدّم أحد المقاولين عرض سعر بقيمة {{amount}} شاملًا الضرائب لـ «{{job}}». راجع عروض الأسعار."
      },
      "taxNoJob": {
        "title": "تم استلام عرض سعر جديد",
        "body": "قدّم {{contractor}} عرض سعر بقيمة {{amount}} شاملًا الضرائب لمهمة. راجع عروض الأسعار."
      },
      "tax": {
        "title": "تم استلام عرض سعر جديد",
        "body": "قدّم {{contractor}} عرض سعر بقيمة {{amount}} شاملًا الضرائب لـ «{{job}}». راجع عروض الأسعار."
      },
      "noContractorNoPriceNoJobLegacy": {
        "title": "تم استلام عرض سعر جديد",
        "body": "قدّم أحد المقاولين عرض سعر لمهمة. راجع عروض الأسعار."
      },
      "noContractorNoPriceNoJob": {
        "title": "تم استلام عرض سعر جديد",
        "body": "قدّم أحد المقاولين عرض سعر لمهمة. راجع عروض الأسعار."
      },
      "noContractorNoPrice": {
        "title": "تم استلام عرض سعر جديد",
        "body": "قدّم أحد المقاولين عرض سعر لـ «{{job}}». راجع عروض الأسعار."
      },
      "noContractorNoJobLegacy": {
        "title": "تم استلام عرض سعر جديد",
        "body": "قدّم أحد المقاولين عرض سعر بقيمة {{amount}} لمهمة. راجع عروض الأسعار."
      },
      "noContractorNoJob": {
        "title": "تم استلام عرض سعر جديد",
        "body": "قدّم أحد المقاولين عرض سعر بقيمة {{amount}} لمهمة. راجع عروض الأسعار."
      },
      "noPriceNoJobLegacy": {
        "title": "تم استلام عرض سعر جديد",
        "body": "قدّم {{contractor}} عرض سعر لمهمة. راجع عروض الأسعار."
      },
      "noPriceNoJob": {
        "title": "تم استلام عرض سعر جديد",
        "body": "قدّم {{contractor}} عرض سعر لمهمة. راجع عروض الأسعار."
      },
      "noContractor": {
        "title": "تم استلام عرض سعر جديد",
        "body": "قدّم أحد المقاولين عرض سعر بقيمة {{amount}} لـ «{{job}}». راجع عروض الأسعار."
      },
      "noPrice": {
        "title": "تم استلام عرض سعر جديد",
        "body": "قدّم {{contractor}} عرض سعر لـ «{{job}}». راجع عروض الأسعار."
      },
      "noJobLegacy": {
        "title": "تم استلام عرض سعر جديد",
        "body": "قدّم {{contractor}} عرض سعر بقيمة {{amount}} لمهمة. راجع عروض الأسعار."
      },
      "noJob": {
        "title": "تم استلام عرض سعر جديد",
        "body": "قدّم {{contractor}} عرض سعر بقيمة {{amount}} لمهمة. راجع عروض الأسعار."
      },
      "default": {
        "title": "تم استلام عرض سعر جديد",
        "body": "قدّم {{contractor}} عرض سعر بقيمة {{amount}} لـ «{{job}}». راجع عروض الأسعار."
      }
    },
    "report_access_declined": {
      "noAsset": {
        "title": "رُفض الوصول إلى التقرير",
        "body": "رُفض طلبك لعرض تقرير الأصل."
      },
      "default": {
        "title": "رُفض الوصول إلى التقرير",
        "body": "رُفض طلبك لعرض تقرير {{asset}}."
      }
    },
    "report_access_granted": {
      "noAsset": {
        "title": "تمت الموافقة على الوصول إلى التقرير",
        "body": "يمكنك الآن عرض تقرير الأصل."
      },
      "default": {
        "title": "تمت الموافقة على الوصول إلى التقرير",
        "body": "يمكنك الآن عرض تقرير {{asset}}."
      }
    },
    "report_access_requested": {
      "noRequesterNoAsset": {
        "title": "طُلب الوصول إلى التقرير.",
        "body": "طلب أحدهم عرض تقرير أحد الأصول."
      },
      "noAsset": {
        "title": "طُلب الوصول إلى التقرير.",
        "body": "طلب {{requester}} عرض تقرير أحد الأصول."
      },
      "noRequester": {
        "title": "طُلب الوصول إلى التقرير.",
        "body": "طلب أحدهم عرض تقرير {{asset}}."
      },
      "default": {
        "title": "طُلب الوصول إلى التقرير.",
        "body": "طلب {{requester}} عرض تقرير {{asset}}."
      },
      "noRequesterNoAssetLegacy": {
        "title": "طُلب الوصول إلى التقرير.",
        "body": "طلب أحدهم عرض تقرير أحد الأصول."
      },
      "noAssetLegacy": {
        "title": "طُلب الوصول إلى التقرير.",
        "body": "طلب {{requester}} عرض تقرير أحد الأصول."
      },
      "noRequesterLegacy": {
        "title": "طُلب الوصول إلى التقرير.",
        "body": "طلب أحدهم عرض تقرير {{asset}}."
      },
      "defaultLegacy": {
        "title": "طُلب الوصول إلى التقرير.",
        "body": "طلب {{requester}} عرض تقرير {{asset}}."
      }
    },
    "request_assigned": {
      "default": {
        "title": "تم تكليفك بطلب",
        "body": "{{request}} بانتظار إجراء منك."
      },
      "byActor": {
        "title": "تم تكليفك بطلب",
        "body": "كلّفك {{actor}} بـ «{{request}}»."
      }
    },
    "request_reassigned": {
      "default": {
        "title": "أُعيد تكليف الطلب",
        "body": "لم تعد مكلّفًا بـ {{request}}."
      }
    },
    "request_team_assigned": {
      "noTeam": {
        "title": "نُقل طلب إلى فريقك",
        "body": "أصبح فريقك يدير {{request}} الآن."
      },
      "default": {
        "title": "نُقل طلب إلى فريقك",
        "body": "أصبح {{team}} يدير {{request}} الآن."
      }
    },
    "request_team_removed": {
      "default": {
        "title": "نُقل طلب من فريقك",
        "body": "لم يعد فريقك يدير {{request}}."
      }
    },
    "rework_requested": {
      "noActorNoJobLegacy": {
        "title": "مطلوب إعادة العمل على مهمتك",
        "body": "أعاد المراجِع مهمة لإعادة العمل. السبب: {{reason}}."
      },
      "noActorNoJob": {
        "title": "مطلوب إعادة العمل على مهمتك",
        "body": "أعاد المراجِع مهمة لإعادة العمل. السبب: {{reason}}"
      },
      "noActor": {
        "title": "مطلوب إعادة العمل على مهمتك",
        "body": "أعاد المراجِع «{{job}}» لإعادة العمل. السبب: {{reason}}"
      },
      "noActorNoJobNoReasonLegacy": {
        "title": "مطلوب إعادة العمل على مهمتك",
        "body": "أعاد المراجِع مهمة لإعادة العمل."
      },
      "noActorNoJobNoReason": {
        "title": "مطلوب إعادة العمل على مهمتك",
        "body": "أعاد المراجِع مهمة لإعادة العمل."
      },
      "noJobLegacy": {
        "title": "مطلوب إعادة العمل على مهمتك",
        "body": "أعاد {{actor}} مهمة لإعادة العمل. السبب: {{reason}}."
      },
      "noJob": {
        "title": "مطلوب إعادة العمل على مهمتك",
        "body": "أعاد {{actor}} مهمة لإعادة العمل. السبب: {{reason}}"
      },
      "noActorNoReason": {
        "title": "مطلوب إعادة العمل على مهمتك",
        "body": "أعاد المراجِع «{{job}}» لإعادة العمل."
      },
      "default": {
        "title": "مطلوب إعادة العمل على مهمتك",
        "body": "أعاد {{actor}} «{{job}}» لإعادة العمل. السبب: {{reason}}"
      },
      "noJobNoReasonLegacy": {
        "title": "مطلوب إعادة العمل على مهمتك",
        "body": "أعاد {{actor}} مهمة لإعادة العمل."
      },
      "noJobNoReason": {
        "title": "مطلوب إعادة العمل على مهمتك",
        "body": "أعاد {{actor}} مهمة لإعادة العمل."
      },
      "noReason": {
        "title": "مطلوب إعادة العمل على مهمتك",
        "body": "أعاد {{actor}} «{{job}}» لإعادة العمل."
      }
    },
    "share_message": {
      "noSender": {
        "title": "رسالة جديدة على تقرير الفحص",
        "body": "أحدهم: {{message}}"
      },
      "default": {
        "title": "رسالة جديدة على تقرير الفحص",
        "body": "{{sender}}: {{message}}"
      }
    },
    "share_response_submitted": {
      "closedOnBehalfNoActorNoRecipient": {
        "title": "أُغلق التقرير دون رد",
        "body": "أغلق فريق الأصل تقرير {{asset}} نيابةً عن المستلم: {{reason}}"
      },
      "closedOnBehalfNoActorNoRecipientNoReason": {
        "title": "أُغلق التقرير دون رد",
        "body": "أغلق فريق الأصل تقرير {{asset}} نيابةً عن المستلم."
      },
      "approvedOnBehalfNoActorNoRecipient": {
        "title": "تمت الموافقة على تقرير الفحص",
        "body": "وقّع فريق الأصل على تقرير {{asset}} نيابةً عن المستلم."
      },
      "closedOnBehalfNoActorNoAssetNoRecipient": {
        "title": "أُغلق التقرير دون رد",
        "body": "أغلق فريق الأصل التقرير نيابةً عن المستلم: {{reason}}"
      },
      "closedOnBehalfNoActorNoAssetNoRecipientNoReason": {
        "title": "أُغلق التقرير دون رد",
        "body": "أغلق فريق الأصل التقرير نيابةً عن المستلم."
      },
      "approvedOnBehalfNoActorNoAssetNoRecipient": {
        "title": "تمت الموافقة على تقرير الفحص",
        "body": "وقّع فريق الأصل على التقرير نيابةً عن المستلم."
      },
      "closedOnBehalfNoActor": {
        "title": "أُغلق التقرير دون رد",
        "body": "أغلق فريق الأصل تقرير {{asset}} نيابةً عن {{recipient}}: {{reason}}"
      },
      "closedOnBehalfNoRecipient": {
        "title": "أُغلق التقرير دون رد",
        "body": "أغلق {{actor}} تقرير {{asset}} نيابةً عن المستلم: {{reason}}"
      },
      "closedOnBehalfNoActorNoReason": {
        "title": "أُغلق التقرير دون رد",
        "body": "أغلق فريق الأصل تقرير {{asset}} نيابةً عن {{recipient}}."
      },
      "closedOnBehalfNoRecipientNoReason": {
        "title": "أُغلق التقرير دون رد",
        "body": "أغلق {{actor}} تقرير {{asset}} نيابةً عن المستلم."
      },
      "approvedOnBehalfNoActor": {
        "title": "تمت الموافقة على تقرير الفحص",
        "body": "وقّع فريق الأصل على تقرير {{asset}} نيابةً عن {{recipient}}."
      },
      "changesNoSigner": {
        "title": "طُلبت تغييرات على تقرير",
        "body": "طلب المستلم تغييرات على تقرير {{asset}}: {{reason}}"
      },
      "approvedOnBehalfNoRecipient": {
        "title": "تمت الموافقة على تقرير الفحص",
        "body": "وقّع {{actor}} على تقرير {{asset}} نيابةً عن المستلم."
      },
      "changesNoSignerNoReason": {
        "title": "طُلبت تغييرات على تقرير",
        "body": "طلب المستلم تغييرات على تقرير {{asset}}."
      },
      "closedOnBehalfNoActorNoAsset": {
        "title": "أُغلق التقرير دون رد",
        "body": "أغلق فريق الأصل التقرير نيابةً عن {{recipient}}: {{reason}}"
      },
      "closedOnBehalfNoAssetNoRecipient": {
        "title": "أُغلق التقرير دون رد",
        "body": "أغلق {{actor}} التقرير نيابةً عن المستلم: {{reason}}"
      },
      "closedOnBehalfNoActorNoAssetNoReason": {
        "title": "أُغلق التقرير دون رد",
        "body": "أغلق فريق الأصل التقرير نيابةً عن {{recipient}}."
      },
      "closedOnBehalfNoAssetNoRecipientNoReason": {
        "title": "أُغلق التقرير دون رد",
        "body": "أغلق {{actor}} التقرير نيابةً عن المستلم."
      },
      "approvedOnBehalfNoActorNoAsset": {
        "title": "تمت الموافقة على تقرير الفحص",
        "body": "وقّع فريق الأصل على التقرير نيابةً عن {{recipient}}."
      },
      "changesNoSignerNoAsset": {
        "title": "طُلبت تغييرات على تقرير",
        "body": "طلب المستلم تغييرات على التقرير: {{reason}}"
      },
      "approvedOnBehalfNoAssetNoRecipient": {
        "title": "تمت الموافقة على تقرير الفحص",
        "body": "وقّع {{actor}} على التقرير نيابةً عن المستلم."
      },
      "changesNoSignerNoAssetNoReason": {
        "title": "طُلبت تغييرات على تقرير",
        "body": "طلب المستلم تغييرات على التقرير."
      },
      "closedOnBehalf": {
        "title": "أُغلق التقرير دون رد",
        "body": "أغلق {{actor}} تقرير {{asset}} نيابةً عن {{recipient}}: {{reason}}"
      },
      "closedOnBehalfNoReason": {
        "title": "أُغلق التقرير دون رد",
        "body": "أغلق {{actor}} تقرير {{asset}} نيابةً عن {{recipient}}."
      },
      "changes": {
        "title": "طُلبت تغييرات على تقرير",
        "body": "طلب {{signer}} تغييرات على تقرير {{asset}}: {{reason}}"
      },
      "approvedNoSigner": {
        "title": "تمت الموافقة على تقرير الفحص",
        "body": "وقّع المستلم على تقرير {{asset}}."
      },
      "approvedOnBehalf": {
        "title": "تمت الموافقة على تقرير الفحص",
        "body": "وقّع {{actor}} على تقرير {{asset}} نيابةً عن {{recipient}}."
      },
      "changesNoReason": {
        "title": "طُلبت تغييرات على تقرير",
        "body": "طلب {{signer}} تغييرات على تقرير {{asset}}."
      },
      "closedOnBehalfNoAsset": {
        "title": "أُغلق التقرير دون رد",
        "body": "أغلق {{actor}} التقرير نيابةً عن {{recipient}}: {{reason}}"
      },
      "closedOnBehalfNoAssetNoReason": {
        "title": "أُغلق التقرير دون رد",
        "body": "أغلق {{actor}} التقرير نيابةً عن {{recipient}}."
      },
      "changesNoAsset": {
        "title": "طُلبت تغييرات على تقرير",
        "body": "طلب {{signer}} تغييرات على التقرير: {{reason}}"
      },
      "approvedNoSignerNoAsset": {
        "title": "تمت الموافقة على تقرير الفحص",
        "body": "وقّع المستلم على التقرير."
      },
      "approvedOnBehalfNoAsset": {
        "title": "تمت الموافقة على تقرير الفحص",
        "body": "وقّع {{actor}} على التقرير نيابةً عن {{recipient}}."
      },
      "changesNoAssetNoReason": {
        "title": "طُلبت تغييرات على تقرير",
        "body": "طلب {{signer}} تغييرات على التقرير."
      },
      "approved": {
        "title": "تمت الموافقة على تقرير الفحص",
        "body": "وقّع {{signer}} على تقرير {{asset}}."
      },
      "approvedNoAsset": {
        "title": "تمت الموافقة على تقرير الفحص",
        "body": "وقّع {{signer}} على التقرير."
      }
    },
    "site_team_assigned": {
      "noTeam": {
        "title": "موقع جديد في فريقك",
        "body": "تم تعيين {{site}} لفريقك."
      },
      "default": {
        "title": "موقع جديد في فريقك",
        "body": "تم تعيين {{site}} لـ {{team}}."
      }
    },
    "site_team_removed": {
      "default": {
        "title": "نُقل موقع من فريقك",
        "body": "لم يعد {{site}} معيّنًا لفريقك."
      }
    },
    "stalled_work_digest": {
      "many": {
        "title": "{{total}} عناصر بانتظار أحدهم",
        "body": "{{itemTitle}} · {{asset}}. {{line}} و{{moreCount}} أخرى."
      },
      "manyNoAsset": {
        "title": "{{total}} عناصر بانتظار أحدهم",
        "body": "{{itemTitle}}. {{line}} و{{moreCount}} أخرى."
      },
      "one": {
        "title": "عنصر بانتظار أحدهم",
        "body": "{{itemTitle}} · {{asset}}. {{line}}"
      },
      "oneNoAsset": {
        "title": "عنصر بانتظار أحدهم",
        "body": "{{itemTitle}}. {{line}}"
      }
    },
    "team_admin_approved": {
      "noMemberLegacy": {
        "title": "أصبح أحد أعضاء الفريق مسؤولًا",
        "body": "وافق المالك على طلبك بشأن أحد أعضاء الفريق."
      },
      "noMember": {
        "title": "أصبح أحد أعضاء الفريق مسؤولًا",
        "body": "وافق المالك على طلبك بشأن أحد أعضاء الفريق."
      },
      "default": {
        "title": "أصبح {{member}} مسؤولًا",
        "body": "وافق المالك على طلبك بشأن {{member}}."
      }
    },
    "team_admin_declined": {
      "noMemberLegacy": {
        "title": "رُفض طلب التعيين كمسؤول",
        "body": "رفض المالك طلبك بتعيين أحد أعضاء الفريق مسؤولًا."
      },
      "noMember": {
        "title": "رُفض طلب التعيين كمسؤول",
        "body": "رفض المالك طلبك بتعيين أحد أعضاء الفريق مسؤولًا."
      },
      "default": {
        "title": "رُفض طلب التعيين كمسؤول",
        "body": "رفض المالك طلبك بتعيين {{member}} مسؤولًا."
      }
    },
    "team_admin_requested": {
      "noMemberNoTeamLegacy": {
        "title": "تعيين أحد أعضاء الفريق مسؤولًا؟",
        "body": "فريقك: يطلب أحد المسؤولين تعيين أحد أعضاء الفريق مسؤولًا."
      },
      "noMemberNoTeam": {
        "title": "تعيين أحد أعضاء الفريق مسؤولًا؟",
        "body": "فريقك: يطلب أحد المسؤولين تعيين أحد أعضاء الفريق مسؤولًا."
      },
      "noMemberLegacy": {
        "title": "تعيين أحد أعضاء الفريق مسؤولًا؟",
        "body": "{{team}}: يطلب أحد المسؤولين تعيين أحد أعضاء الفريق مسؤولًا."
      },
      "noMember": {
        "title": "تعيين أحد أعضاء الفريق مسؤولًا؟",
        "body": "{{team}}: يطلب أحد المسؤولين تعيين أحد أعضاء الفريق مسؤولًا."
      },
      "noTeam": {
        "title": "تعيين {{member}} مسؤولًا؟",
        "body": "فريقك: يطلب أحد المسؤولين تعيين {{member}} مسؤولًا."
      },
      "default": {
        "title": "تعيين {{member}} مسؤولًا؟",
        "body": "{{team}}: يطلب أحد المسؤولين تعيين {{member}} مسؤولًا."
      }
    },
    "team_invite_accepted": {
      "noTeam": {
        "title": "تم قبول دعوة مساحة العمل",
        "body": "قبل {{email}} الدعوة إلى فريقك."
      },
      "default": {
        "title": "تم قبول دعوة مساحة العمل",
        "body": "قبل {{email}} الدعوة إلى {{team}}."
      }
    },
    "team_invite_declined": {
      "noTeam": {
        "title": "تم رفض دعوة مساحة العمل",
        "body": "رفض {{email}} الدعوة إلى فريقك."
      },
      "default": {
        "title": "تم رفض دعوة مساحة العمل",
        "body": "رفض {{email}} الدعوة إلى {{team}}."
      }
    },
    "team_invited": {
      "noTeam": {
        "title": "دعوة إلى مساحة العمل",
        "body": "تمت دعوتك للانضمام إلى فريق في مساحة عمل."
      },
      "default": {
        "title": "دعوة إلى مساحة العمل",
        "body": "تمت دعوتك للانضمام إلى {{team}}."
      }
    },
    "team_member_added": {
      "noTeam": {
        "title": "تمت إضافتك إلى فريق في مساحة العمل",
        "body": "فريقك."
      },
      "default": {
        "title": "تمت إضافتك إلى فريق في مساحة العمل",
        "body": "{{team}}."
      }
    },
    "team_member_removed": {
      "noTeam": {
        "title": "تمت إزالتك من فريق في مساحة العمل",
        "body": "فريقك."
      },
      "default": {
        "title": "تمت إزالتك من فريق في مساحة العمل",
        "body": "{{team}}."
      }
    },
    "team_member_role_changed": {
      "noTeam": {
        "title": "تغيّر دورك في مساحة العمل",
        "body": "فريقك · الدور: {{role}}"
      },
      "default": {
        "title": "تغيّر دورك في مساحة العمل",
        "body": "{{team}} · الدور: {{role}}"
      }
    },
    "team_ownership_accepted": {
      "noWorkspace": {
        "title": "قُبلت ملكية مساحة العمل",
        "body": "تم قبول نقل ملكية مساحة العمل."
      },
      "default": {
        "title": "قُبلت ملكية مساحة العمل",
        "body": "تم قبول نقل ملكية {{workspace}}."
      }
    },
    "team_ownership_cancelled": {
      "noWorkspace": {
        "title": "أُلغي نقل ملكية مساحة العمل",
        "body": "أُلغي نقل ملكية مساحة العمل."
      },
      "default": {
        "title": "أُلغي نقل ملكية مساحة العمل",
        "body": "أُلغي نقل ملكية {{workspace}}."
      }
    },
    "team_ownership_declined": {
      "noWorkspace": {
        "title": "رُفضت ملكية مساحة العمل",
        "body": "رُفض نقل ملكية مساحة العمل."
      },
      "default": {
        "title": "رُفضت ملكية مساحة العمل",
        "body": "رُفض نقل ملكية {{workspace}}."
      }
    },
    "team_ownership_expired": {
      "noWorkspaceLegacy": {
        "title": "انتهت صلاحية عرض ملكية مساحة العمل",
        "body": "انتهت صلاحية نقل ملكية مساحة العمل."
      },
      "noWorkspace": {
        "title": "انتهت صلاحية عرض ملكية مساحة العمل",
        "body": "انتهت صلاحية نقل ملكية مساحة العمل."
      },
      "defaultLegacy": {
        "title": "انتهت صلاحية عرض ملكية مساحة العمل",
        "body": "انتهت صلاحية نقل ملكية {{workspace}}."
      },
      "default": {
        "title": "انتهت صلاحية عرض ملكية مساحة العمل",
        "body": "انتهت صلاحية نقل ملكية {{workspace}}."
      }
    },
    "team_ownership_requested": {
      "noWorkspace": {
        "title": "عُرضت عليك ملكية مساحة العمل",
        "body": "مساحة عمل بانتظار قرارك."
      },
      "default": {
        "title": "عُرضت عليك ملكية مساحة العمل",
        "body": "{{workspace}} بانتظار قرارك."
      }
    },
    "work_change_approved": {
      "byPolicyNoWork": {
        "title": "تم التخطي وفق سياسة الخطة: عمل مجدول",
        "body": "{{reason}}"
      },
      "byPolicy": {
        "title": "تم التخطي وفق سياسة الخطة: {{work}}",
        "body": "{{reason}}"
      },
      "decided": {
        "title": "تمت الموافقة على التغيير",
        "body": "تمت الموافقة على {{action}}"
      }
    },
    "work_change_rejected": {
      "default": {
        "title": "لم تتم الموافقة على التغيير",
        "body": "هذا العمل لا يزال مستحقًا"
      }
    },
    "work_change_requested": {
      "noWork": {
        "title": "طُلب تغيير: عمل مجدول",
        "body": "{{reason}}"
      },
      "default": {
        "title": "طُلب تغيير: {{work}}",
        "body": "{{reason}}"
      }
    },
    "work_needs_assignee": {
      "raisedNoAsset": {
        "title": "لم يُعيَّن أحد بعد",
        "body": "\"{{work}}\" مستحق في {{dueDate}}. عيّن شخصًا قبل ذلك."
      },
      "reminderNoAsset": {
        "title": "لا يزال لم يُعيَّن أحد",
        "body": "\"{{work}}\" مستحق في {{dueDate}}. عيّن شخصًا أو أنجزه بنفسك."
      },
      "raised": {
        "title": "لم يُعيَّن أحد بعد",
        "body": "\"{{work}}\" · {{asset}} مستحق في {{dueDate}}. عيّن شخصًا قبل ذلك."
      },
      "reminder": {
        "title": "لا يزال لم يُعيَّن أحد",
        "body": "\"{{work}}\" · {{asset}} مستحق في {{dueDate}}. عيّن شخصًا أو أنجزه بنفسك."
      }
    },
    "work_rescheduled": {
      "noInspection": {
        "title": "أُعيدت الجدولة",
        "body": "فحص · {{asset}}: الموعد الآن {{when}}."
      },
      "noInspectionNoAsset": {
        "title": "أُعيدت الجدولة",
        "body": "الفحص: الموعد الآن {{when}}."
      },
      "noJob": {
        "title": "أُعيدت الجدولة",
        "body": "مهمة · {{asset}}: الموعد الآن {{when}}."
      },
      "noJobNoAsset": {
        "title": "أُعيدت الجدولة",
        "body": "مهمة: الموعد الآن {{when}}."
      },
      "default": {
        "title": "أُعيدت الجدولة",
        "body": "{{work}} · {{asset}}: الموعد الآن {{when}}."
      },
      "noAsset": {
        "title": "أُعيدت الجدولة",
        "body": "{{work}}: الموعد الآن {{when}}."
      }
    },
    "work_unscheduled": {
      "noInspection": {
        "title": "لم يعد مجدولًا",
        "body": "فحص · {{asset}}: لم يعد مجدولًا."
      },
      "noInspectionNoAsset": {
        "title": "لم يعد مجدولًا",
        "body": "الفحص لم يعد مجدولًا."
      },
      "noJob": {
        "title": "لم يعد مجدولًا",
        "body": "مهمة · {{asset}}: لم تعد مجدولة."
      },
      "noJobNoAsset": {
        "title": "لم يعد مجدولًا",
        "body": "إحدى المهام لم تعد مجدولة."
      },
      "default": {
        "title": "لم يعد مجدولًا",
        "body": "{{work}} · {{asset}}: لم يعد مجدولًا."
      },
      "noAsset": {
        "title": "لم يعد مجدولًا",
        "body": "{{work}}: لم يعد مجدولًا."
      }
    },
    "esg_certificate_expiring": {
      "expired": {
        "title": "انتهت شهادة الطاقة: {{place}}",
        "body": "تنتهي {{scheme}} (التصنيف {{rating}}) في {{endDate}}. احجز تقييمًا جديدًا ليبقى التأجير أو البيع ممكنًا."
      },
      "inDays": {
        "title": "تنتهي شهادة الطاقة خلال {{daysLeft}} يومًا: {{place}}",
        "body": "تنتهي {{scheme}} (التصنيف {{rating}}) في {{endDate}}. احجز تقييمًا جديدًا ليبقى التأجير أو البيع ممكنًا."
      }
    }
  },
  "lines": {
    "shareNotAcceptedOne": "لم يقبل {{waitingOn}} الوصول إلى هذا الأصل منذ {{days}} يوم. أرسل تذكيرًا أو أزل المشاركة.",
    "shareNotAccepted": "لم يقبل {{waitingOn}} الوصول إلى هذا الأصل منذ {{days}} يوم. أرسل تذكيرًا أو أزل المشاركة.",
    "expiredNotRenewedOne": "انتهت صلاحيته منذ {{days}} يوم ولم يجدّده أحد.",
    "expiredNotRenewed": "انتهت صلاحيته منذ {{days}} يوم ولم يجدّده أحد.",
    "fixNotConfirmedOne": "لم يؤكّد {{waitingOn}} الإصلاح منذ {{days}} يوم. أرسل تذكيرًا.",
    "fixNotConfirmed": "لم يؤكّد {{waitingOn}} الإصلاح منذ {{days}} يوم. أرسل تذكيرًا.",
    "notRedoneOne": "لم يُعِد {{waitingOn}} تنفيذ هذا منذ {{days}} يوم. أرسل تذكيرًا أو أعد تكليفه.",
    "notRedone": "لم يُعِد {{waitingOn}} تنفيذ هذا منذ {{days}} يوم. أرسل تذكيرًا أو أعد تكليفه.",
    "inviteNotAcceptedOne": "لم يقبل {{waitingOn}} الدعوة منذ {{days}} يوم. أعد إرسالها أو اسحبها.",
    "inviteNotAccepted": "لم يقبل {{waitingOn}} الدعوة منذ {{days}} يوم. أعد إرسالها أو اسحبها.",
    "approvedNoWorkOne": "تمت الموافقة عليه منذ {{days}} يوم ولم يُنشأ أي عمل بعد.",
    "approvedNoWork": "تمت الموافقة عليه منذ {{days}} يوم ولم يُنشأ أي عمل بعد.",
    "overdueOne": "كان مستحقًا منذ {{days}} يوم ولم يُنجز بعد.",
    "overdue": "كان مستحقًا منذ {{days}} يوم ولم يُنجز بعد.",
    "overdueUnassignedOne": "كان مستحقًا منذ {{days}} يوم ولا أحد مكلّف به. كلّف به أحدًا أو نفّذه بنفسك.",
    "overdueUnassigned": "كان مستحقًا منذ {{days}} يوم ولا أحد مكلّف به. كلّف به أحدًا أو نفّذه بنفسك.",
    "overdueNotDoneOne": "كان مستحقًا منذ {{days}} يوم ولم ينفّذه {{waitingOn}}. أعد تكليفه أو نفّذه بنفسك.",
    "overdueNotDone": "كان مستحقًا منذ {{days}} يوم ولم ينفّذه {{waitingOn}}. أعد تكليفه أو نفّذه بنفسك.",
    "quotesStalledOne": "لم يحدث أي تقدّم في عروض الأسعار هذه منذ {{days}} يوم. اختر أحدها، أو أرسل تذكيرًا، أو حدّد موعدًا نهائيًا.",
    "quotesStalled": "لم يحدث أي تقدّم في عروض الأسعار هذه منذ {{days}} يوم. اختر أحدها، أو أرسل تذكيرًا، أو حدّد موعدًا نهائيًا.",
    "awaitingYourValidationOne": "بانتظار تصديقك منذ {{days}} يوم.",
    "awaitingYourValidation": "بانتظار تصديقك منذ {{days}} يوم.",
    "quoteDeadlinePassedOne": "انقضى الموعد النهائي لعروض الأسعار منذ {{days}} يوم. اختر أحدها، أو أرسل تذكيرًا، أو حدّد موعدًا جديدًا.",
    "quoteDeadlinePassed": "انقضى الموعد النهائي لعروض الأسعار منذ {{days}} يوم. اختر أحدها، أو أرسل تذكيرًا، أو حدّد موعدًا جديدًا.",
    "awaitingYourPickupOne": "بانتظار أن تتولى هذا منذ {{days}} يوم.",
    "awaitingYourPickup": "بانتظار أن تتولى هذا منذ {{days}} يوم.",
    "awaitingYourApprovalOne": "بانتظار موافقتك منذ {{days}} يوم.",
    "awaitingYourApproval": "بانتظار موافقتك منذ {{days}} يوم.",
    "noResponseOne": "لا رد من {{waitingOn}} منذ {{days}} يوم.",
    "noResponse": "لا رد من {{waitingOn}} منذ {{days}} يوم.",
    "notValidatedOne": "لم يصدّق {{waitingOn}} على هذا منذ {{days}} يوم.",
    "notValidated": "لم يصدّق {{waitingOn}} على هذا منذ {{days}} يوم.",
    "inviteNotAnsweredOne": "لم يردّ {{waitingOn}} على الدعوة منذ {{days}} يوم. أرسل تذكيرًا أو كلّف شخصًا آخر.",
    "inviteNotAnswered": "لم يردّ {{waitingOn}} على الدعوة منذ {{days}} يوم. أرسل تذكيرًا أو كلّف شخصًا آخر.",
    "notRepliedOne": "لم يردّ {{waitingOn}} منذ {{days}} يوم.",
    "notReplied": "لم يردّ {{waitingOn}} منذ {{days}} يوم.",
    "notApprovedOne": "لم يوافق {{waitingOn}} على هذا منذ {{days}} يوم.",
    "notApproved": "لم يوافق {{waitingOn}} على هذا منذ {{days}} يوم."
  },
  "values": {
    "featureStatus": {
      "under_review": "قيد المراجعة",
      "planned": "مخطط لها",
      "in_progress": "قيد التطوير",
      "shipped": "متاحة في التطبيق الآن",
      "not_planned": "غير مخطط لها حاليًا",
      "considering": "قيد الدراسة"
    },
    "reason": {
      "fault": "عطل",
      "end_of_life": "نهاية العمر",
      "replaced": "تم استبداله",
      "seasonal": "موسمي",
      "relocated": "تم نقله",
      "decommissioned": "أُوقف تشغيله",
      "sold": "تم بيعه",
      "disposed": "تم التخلص منه",
      "lost": "مفقود",
      "other": "أخرى"
    },
    "period": {
      "am": "ص",
      "pm": "م"
    },
    "periodLabel": {
      "morning": "صباحًا",
      "afternoon": "بعد الظهر"
    },
    "documentType": {
      "certificate": "شهادة",
      "warranty": "ضمان",
      "compliance_document": "مستند امتثال",
      "document": "مستند"
    },
    "role": {
      "owner": "مالك",
      "admin": "مسؤول",
      "member": "عضو"
    },
    "action": {
      "skip": "التخطي",
      "reschedule": "إعادة الجدولة",
      "reassign": "إعادة التكليف"
    },
    "itemTitle": {
      "inspection": "فحص",
      "job": "مهمة",
      "document": "مستند",
      "request": "طلب",
      "scheduled_inspection": "فحص مجدول",
      "invitation_to_the_team": "دعوة إلى الفريق"
    },
    "waitingOn": {
      "the_recipient": "المستلم",
      "asset_approver": "معتمِد الأصل",
      "the_approver": "المعتمِد",
      "the_requester": "مقدّم الطلب",
      "the_assignee": "المكلَّف",
      "the_validator": "مسؤول التصديق",
      "the_team": "الفريق",
      "the_contractors_you_asked": "المقاولون الذين طلبت منهم",
      "the_contractor": "المقاول",
      "the_invitee": "المدعو",
      "nobody": "لا أحد",
      "The_recipient": "المستلم",
      "The_approver": "المعتمِد",
      "The_requester": "مقدّم الطلب",
      "The_assignee": "المكلَّف",
      "The_validator": "مسؤول التصديق",
      "The_team": "الفريق",
      "The_contractor": "المقاول",
      "The_invitee": "المدعو"
    }
  }
};
